import {
  PlayerIndexMap,
  RenderPlayerIdentity,
  Team01,
} from "./GameStoryDialog_UPDATED";
import { KitchenArrivalRow, ShotNumberOverlay } from "./RallyBoardPopup";
import * as React from "react";
import { Box, Button, Slider, Typography } from "@mui/material";
import { ActiveRallyVideo } from "./ActiveRallyVideo";
import { FirefightClip } from "./GameStory_firefights";
// import { FloatingPanel } from "./GameStory_3rdShotPopup";
import { FloatingPanel } from "./GameStory_3rdShotPopup_only_updated_v2_Mar_18_2026";

import { teamRgba } from "./GameStoryDialog";

const MINI_COURT_HEIGHT = 100;
const MINI_COURT_WIDTH = 120;

function CourtMiniPair(props: {
  p: PairPoint;
  teamColor: (team: Team01, alpha?: number) => string;
  flipX: boolean;
  aLabel: string;
  bLabel: string;
}) {
  const { p, teamColor, flipX, aLabel, bLabel } = props;

  // tiny court (20x44 feet mapping)
  const W = MINI_COURT_WIDTH; //120;
  const H = MINI_COURT_HEIGHT; //220;
  const PAD = 10;

  const sx = (xFeet: number) =>
    flipX ? (1 - xFeet / 20) * W : (xFeet / 20) * W;

  // Keep the same baseline orientation logic as CourtSvg for the hitter team
  const yRel = (yAbs: number) => (p.hitterTeam === 1 ? 44 - yAbs : yAbs);
  const sy = (yAbsFeet: number) =>
    p.hitterTeam === 0
      ? (yRel(yAbsFeet) / 44) * H
      : (1 - yRel(yAbsFeet) / 44) * H;

  const ax = sx(p.ax);
  const ay = sy(p.ay);
  const bx = p.bx != null ? sx(p.bx) : null;
  const by = p.by != null ? sy(p.by) : null;

  const k = (7 / 44) * H;
  const kitchenTop = H / 2 - k;
  const kitchenBot = H / 2 + k;

  return (
    <Box
      sx={{
        width: W,
        height: H,
        // border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: 1,
        bgcolor: "rgba(255,255,255,0.94)",
        overflow: "hidden",
      }}
    >
      <svg
        viewBox={`${-PAD} ${-PAD} ${W + PAD * 2} ${H + PAD * 2}`}
        style={{ width: "100%", height: "100%", display: "block" }}
      >
        {/* outer */}
        <rect
          x="0"
          y="0"
          width={W}
          height={H}
          fill="none"
          stroke="rgba(0,0,0,0.18)"
        />

        {/* net */}
        <line
          x1="0"
          y1={H / 2}
          x2={W}
          y2={H / 2}
          stroke="rgba(0,0,0,0.25)"
          strokeWidth={1}
        />

        {/* kitchen */}
        <line
          x1="0"
          y1={kitchenTop}
          x2={W}
          y2={kitchenTop}
          stroke="rgba(0,0,0,0.18)"
          strokeWidth={1}
        />
        <line
          x1="0"
          y1={kitchenBot}
          x2={W}
          y2={kitchenBot}
          stroke="rgba(0,0,0,0.18)"
          strokeWidth={1}
        />

        {/* center line (skip kitchen zone) */}
        <line
          x1={W / 2}
          y1="0"
          x2={W / 2}
          y2={kitchenTop}
          stroke="rgba(0,0,0,0.12)"
          strokeWidth={1}
        />
        <line
          x1={W / 2}
          y1={kitchenBot}
          x2={W / 2}
          y2={H}
          stroke="rgba(0,0,0,0.12)"
          strokeWidth={1}
        />

        {p.hasB && bx != null && by != null ? (
          <line
            x1={ax}
            y1={ay}
            x2={bx}
            y2={by}
            stroke={teamColor(p.hitterTeam, 0.45)}
            strokeWidth={2}
            strokeDasharray="4 4"
          />
        ) : null}

        {/* A dot */}
        {p.lostOnShotA && (
          <circle
            cx={ax}
            cy={ay}
            r={8.2}
            fill="none"
            stroke="rgba(220, 38, 38, 0.95)"
            strokeWidth={2.2}
          />
        )}

        {p.lostOnShotA ? (
          <>
            <line
              x1={ax - 4.8}
              y1={ay - 4.8}
              x2={ax + 4.8}
              y2={ay + 4.8}
              stroke="black"
              strokeWidth={2}
            />
            <line
              x1={ax - 4.8}
              y1={ay + 4.8}
              x2={ax + 4.8}
              y2={ay - 4.8}
              stroke="black"
              strokeWidth={2}
            />
          </>
        ) : null}

        <circle
          cx={ax}
          cy={ay}
          r={4.8}
          fill={teamColor(p.hitterTeam, 0.92)}
          stroke="rgba(0,0,0,0.18)"
        />

        {/* {p.hasB && bx != null && by != null ? (
          <>
            <circle
              cx={bx}
              cy={by}
              r={5.2}
              fill="rgba(255,255,255,0.9)"
              stroke={teamColor(otherTeam(p.hitterTeam), 0.75)}
              strokeWidth={3}
            />

            {p.lostOnShotB ? (
              <>
                <line
                  x1={bx - 4.8}
                  y1={by - 4.8}
                  x2={bx + 4.8}
                  y2={by + 4.8}
                  stroke="black"
                  strokeWidth={2}
                />
                <line
                  x1={bx - 4.8}
                  y1={by + 4.8}
                  x2={bx + 4.8}
                  y2={by - 4.8}
                  stroke="black"
                  strokeWidth={2}
                />
              </>
            ) : null}



          </>
        ) : null} */}

        {p.hasB && bx != null && by != null ? (
          <>
            {p.lostOnShotB && (
              <circle
                cx={bx}
                cy={by}
                r={8.2}
                fill="none"
                stroke="rgba(220, 38, 38, 0.95)"
                strokeWidth={2.2}
              />
            )}

            <circle
              cx={bx}
              cy={by}
              r={5.2}
              fill="rgba(255,255,255,0.9)"
              stroke={teamColor(otherTeam(p.hitterTeam), 0.75)}
              strokeWidth={3}
            />

            {p.lostOnShotB ? (
              <>
                <line
                  x1={bx - 4.8}
                  y1={by - 4.8}
                  x2={bx + 4.8}
                  y2={by + 4.8}
                  stroke="black"
                  strokeWidth={2}
                />
                <line
                  x1={bx - 4.8}
                  y1={by + 4.8}
                  x2={bx + 4.8}
                  y2={by - 4.8}
                  stroke="black"
                  strokeWidth={2}
                />
              </>
            ) : null}
          </>
        ) : null}
      </svg>
    </Box>
  );
}

const COURT_SVG_W = 200;
const COURT_SVG_H = 320;
const COURT_ASPECT_RATIO = COURT_SVG_W / COURT_SVG_H;

export type ServeReturnPopupMode = "serve_return" | "return_third";

type SvgViewBox = { minX: number; minY: number; w: number; h: number };

const otherTeam = (t: Team01): Team01 => (t === 0 ? 1 : 0);

function computeViewBoxForTeam(args: {
  team: Team01;
  points: PairPoint[];
  sxAbsToSvg: (xFeet: number) => number;
  syAbsToSvg: (team: Team01, yAbsFeet: number) => number;
  xPad: number;
  yPad: number;
}) {
  const { team, points, sxAbsToSvg, syAbsToSvg, xPad, yPad } = args;

  const pts = points.filter((p) => p.hitterTeam === team);

  if (!pts.length) {
    return {
      minX: -xPad,
      maxX: COURT_SVG_W + xPad, //200 + xPad,
      minY: -yPad,
      maxY: COURT_SVG_H + yPad,
    };
  }

  let minX = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;

  for (const p of pts) {
    const ax = sxAbsToSvg(p.ax);
    const ay = syAbsToSvg(team, p.ay);
    // const bx = sxAbsToSvg(p.bx);
    // const by = syAbsToSvg(team, p.by);

    // minX = Math.min(minX, ax, bx);
    // maxX = Math.max(maxX, ax, bx);
    // minY = Math.min(minY, ay, by);
    // maxY = Math.max(maxY, ay, by);

    const bx = p.bx != null ? sxAbsToSvg(p.bx) : null;
    const by = p.by != null ? syAbsToSvg(team, p.by) : null;

    minX = Math.min(minX, ax, bx ?? ax);
    maxX = Math.max(maxX, ax, bx ?? ax);
    minY = Math.min(minY, ay, by ?? ay);
    maxY = Math.max(maxY, ay, by ?? ay);
  }

  return {
    minX: minX - xPad,
    maxX: maxX + xPad,
    minY: minY - yPad,
    maxY: maxY + yPad,
  };
}

function unionViewBox(
  a: { minX: number; maxX: number; minY: number; maxY: number },
  b: { minX: number; maxX: number; minY: number; maxY: number },
): SvgViewBox {
  const minX = Math.min(a.minX, b.minX);
  const maxX = Math.max(a.maxX, b.maxX);
  const minY = Math.min(a.minY, b.minY);
  const maxY = Math.max(a.maxY, b.maxY);

  return {
    minX,
    minY,
    w: maxX - minX,
    h: maxY - minY,
  };
}

type FloatingRect = { x: number; y: number; w: number; h: number };

type PlayerStatRow = {
  playerId: number;
  total: number;
  win: number;
  loss: number;
  unk: number;
  missA: number;
  missB: number;
  missTotal: number;
};

type PairPoint = {
  rallyIndex: number;
  pointKey: string | number | null;

  hitterTeam: Team01;
  hitterPlayerId: number | null;
  receiverPlayerId: number | null;
  wonRally: boolean | null;

  // feet in court coords (usually 0..20, 0..44, but can be outside)
  ax: number;
  ay: number;
  bx: number | null;
  by: number | null;
  endX: number | null;
  endY: number | null;
  landingDepthFromOpponentBaselineFt: number | null;

  mph?: number;

  winnerTeam: Team01 | null;
  missA: boolean;
  missB: boolean;

  lostOnShotA: boolean;
  lostOnShotB: boolean;
  hasB: boolean;
};

function statsByPlayer(points: PairPoint[], team: 0 | 1): PlayerStatRow[] {
  const m = new Map<number, PlayerStatRow>();

  const ensure = (pid: number) => {
    let row = m.get(pid);
    if (!row) {
      row = {
        playerId: pid,
        total: 0,
        win: 0,
        loss: 0,
        unk: 0,
        missA: 0,
        missB: 0,
        missTotal: 0,
      };
      m.set(pid, row);
    }
    return row;
  };

  for (const p of points) {
    if (p.hitterTeam === team && typeof p.hitterPlayerId === "number") {
      const row = ensure(p.hitterPlayerId);

      row.total += 1;
      if (p.missA) row.missA += 1;

      if (p.wonRally === true) row.win += 1;
      else if (p.wonRally === false) row.loss += 1;
      else row.unk += 1;
    }

    if (
      otherTeam(p.hitterTeam) === team &&
      typeof p.receiverPlayerId === "number"
    ) {
      const row = ensure(p.receiverPlayerId);
      if (p.missB) row.missB += 1;
    }
  }

  // for (const row of m.values()) {
  //   row.missTotal = row.missA + row.missB;
  // }

  m.forEach((row) => {
    row.missTotal = row.missA + row.missB;
  });

  return Array.from(m.values()).sort((a, b) => a.playerId - b.playerId);
}

function statsByPlayer_old(points: PairPoint[], team: 0 | 1): PlayerStatRow[] {
  const m = new Map<number, PlayerStatRow>();

  for (const p of points) {
    if (p.hitterTeam !== team) continue;
    const pid = p.hitterPlayerId;
    if (typeof pid !== "number") continue;

    let row = m.get(pid);
    if (!row) {
      //row = { playerId: pid, total: 0, win: 0, loss: 0, unk: 0 };
      row = {
        playerId: pid,
        total: 0,
        win: 0,
        loss: 0,
        unk: 0,
        missA: 0,
        missB: 0,
        missTotal: 0,
      };
      m.set(pid, row);
    }

    row.total += 1;

    if (p.missA) row.missA += 1;
    if (p.missB) row.missB += 1;
    row.missTotal = row.missA + row.missB;

    if (p.wonRally === true) row.win += 1;
    else if (p.wonRally === false) row.loss += 1;
    else row.unk += 1;
  }

  return Array.from(m.values()).sort((a, b) => a.playerId - b.playerId);
}

function PlayerFilter(props: {
  team: 0 | 1;
  teamColor: (team: 0 | 1, alpha?: number) => string;
  availablePlayerIds: number[];
  selectedPlayerId: number | null;
  onSelect: (pid: number | null) => void;
  renderPlayerIdentity: RenderPlayerIdentity;
}) {
  const {
    team,
    teamColor,
    availablePlayerIds,
    selectedPlayerId,
    onSelect,
    renderPlayerIdentity,
  } = props;
  if (!availablePlayerIds.length) return null;

  return (
    <Box sx={{ mt: 0.75 }}>
      <Box sx={{ fontSize: 16, fontWeight: 800, color: teamColor(team, 0.9) }}>Team {team}</Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 0.5 }}>
        <Box
          data-happy-path="shot-location-player-filter-all"
          data-selected={selectedPlayerId == null ? "true" : "false"}
          onClick={() => onSelect(null)}
          sx={{
            height: 34,
            px: 1,
            borderRadius: "8px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            userSelect: "none",
            fontWeight: 900,
            fontSize: 13,
            border: "1px solid transparent",
            bgcolor: selectedPlayerId == null ? "rgba(0,0,0,0.07)" : "white",
            boxShadow:
              selectedPlayerId == null
                ? "inset 0 0 0 1px rgba(0,0,0,0.20)"
                : "none",
          }}
        >
          All
        </Box>
        {availablePlayerIds.map((pid) => {
          const selected = selectedPlayerId === pid;
          return (
            <Box
              key={pid}
              data-happy-path="shot-location-player-filter"
              data-shot-location-team={team}
              data-shot-location-player-id={pid}
              data-selected={selected ? "true" : "false"}
              onClick={() => onSelect(selected ? null : pid)}
              sx={{
                minWidth: 0,
                height: 34,
                px: 0.75,
                borderRadius: "2px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                userSelect: "none",
                border: "1px solid transparent",
                bgcolor: selected ? teamColor(team, 0.16) : "white",
                boxShadow: selected
                  ? `inset 0 0 0 1px ${teamColor(team, 0.5)}`
                  : "none",
              }}
            >
              {renderPlayerIdentity
                ? renderPlayerIdentity({
                    playerId: pid,
                    labelOnly: false,
                    size: 34,
                    borderRadius: 5,
                    fontSize: 12,
                  })
                : `p${pid}`}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

function TeamSummary(props: {
  team: 0 | 1;
  title: string;
  points: PairPoint[];
  allPoints: PairPoint[];
  playerStats: PlayerStatRow[];
  selectedPlayerId: number | null;
  teamColor: (team: 0 | 1, alpha?: number) => string;
  renderPlayerIdentity: RenderPlayerIdentity;
  aLabel: string;
  bLabel: string;
}) {
  const {
    team,
    title,
    points,
    playerStats,
    selectedPlayerId,
    teamColor,
    renderPlayerIdentity,
    aLabel,
    bLabel,
    allPoints,
  } = props;

  // const total = points.length;

  //   const missA = points.filter((p) => p.missA).length;
  // const missB = points.filter((p) => p.missB).length;
  // const missTotal = missA + missB;

  // const win = points.filter((p) => p.wonRally === true).length;
  // const loss = points.filter((p) => p.wonRally === false).length;

  // const total = points.length;

  // const missA = allPoints.filter(
  //   (p) => p.hitterTeam === team && p.missA,
  // ).length;

  // const missB = allPoints.filter(
  //   (p) => otherTeam(p.hitterTeam) === team && p.missB,
  // ).length;

  // const missTotal = missA + missB;

  // const total = points.length;

  //   const missA = allPoints.filter(
  //     (p) => p.hitterTeam === team && p.missA,
  //   ).length;

  // const hitA = allPoints.filter(
  //   (p) => p.hitterTeam === team,
  // ).length;

  // const missB = allPoints.filter(
  //   (p) => otherTeam(p.hitterTeam) === team && p.missB,
  // ).length;

  // const hitB = allPoints.filter(
  //   (p) => otherTeam(p.hitterTeam) === team,
  // ).length;
  

    const total = points.length;

  const missA = allPoints.filter((p) => p.hitterTeam === team && p.missA).length;
  const hitA = allPoints.filter((p) => p.hitterTeam === team).length;

  // const missB = allPoints.filter(
  //   (p) => otherTeam(p.hitterTeam) === team && p.missB,
  // ).length;

    const missB = allPoints.filter(
    (p) =>
      otherTeam(p.hitterTeam) === team &&
      p.hasB &&
      typeof p.receiverPlayerId === "number" &&
      p.missB,
  ).length;
  // const hitB = allPoints.filter(
  //   (p) => otherTeam(p.hitterTeam) === team,
  // ).length;

    const hitB = allPoints.filter(
    (p) =>
      otherTeam(p.hitterTeam) === team &&
      p.hasB &&
      typeof p.receiverPlayerId === "number",
  ).length;


  const playerHitA = (playerId: number) =>
    allPoints.filter(
      (p) => p.hitterTeam === team && p.hitterPlayerId === playerId,
    ).length;

  const playerHitB = (playerId: number) =>
    allPoints.filter(
      (p) => otherTeam(p.hitterTeam) === team && p.receiverPlayerId === playerId,
    ).length;

  const missTotal = missA + missB;
  const win = points.filter((p) => p.wonRally === true).length;
  const loss = points.filter((p) => p.wonRally === false).length;
  return (
    <Box
      sx={{
        // border: "1px solid rgba(0,0,0,0.16)",
        borderRadius: 1,
        p: 0.8,
        bgcolor: "rgba(255,255,255,0.94)",
      }}
    >
      <Box
        sx={{
          fontSize: 14,
          fontWeight: 900,
          color: teamColor(team, 0.95),
          mb: 0.5,
        }}
      >
        {title}
      </Box>
      {/* <Box sx={{ fontSize: 11.5 }}>Total: {total}</Box>
      <Box sx={{ fontSize: 11.5 }}>
        Won: {win} · Lost: {loss}
      </Box>
      <Box sx={{ fontSize: 11.5, mb: 0.6 }}>
        Misses: {missTotal}
        {missA || missB ? ` (${aLabel}: ${missA}, ${bLabel}: ${missB})` : ""}
      </Box> */}

      <Box sx={{ fontSize: 11.5 }}>Total {aLabel.toLowerCase()}s: {hitA} (missed {missA})</Box>

        {/* <Box sx={{ fontSize: 11.5 }}>
          Missed {aLabel.toLowerCase()}s: {missA}
        </Box> */}
      <Box sx={{ fontSize: 11.5 }}>Total {bLabel.toLowerCase()}s: {hitB} (missed {missB})</Box>
      {/* <Box sx={{ fontSize: 11.5, mb: 0.6 }}>Misses: {missTotal}</Box> */}
      {/* <Box sx={{ fontSize: 11.5, mb: 0.6 }}>
        Missed {bLabel.toLowerCase()}s: {missB}
      </Box> */}

      {playerStats.length > 0 && (
        <Box sx={{ marginTop:"3px",}}>
          {/* <Box
            sx={{ fontSize: 11.5, fontWeight: 800, opacity: 0.82, mb: 0.35 }}
          >
            By player
          </Box> */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.35 }}>
            {/* {playerStats.map((r) => (
              <Box
                key={r.playerId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.5,
                  bgcolor:
                    selectedPlayerId === r.playerId
                      ? teamColor(team, 0.08)
                      : "transparent",
                  borderRadius: 1,
                  px: 0.25,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.45,
                    minWidth: 0,
                  }}
                >
                  {renderPlayerIdentity
                    ? renderPlayerIdentity({
                        playerId: r.playerId,
                        labelOnly: false,
                        size: 28,
                        borderRadius: 5,
                        fontSize: 11,
                      })
                    : null}
                </Box>
                <Box sx={{ fontSize: 11.5, whiteSpace: "nowrap" }}>
                  {r.win} won, {r.loss} lost
                  {r.missTotal
                    ? ` · ${r.missTotal} miss${r.missTotal === 1 ? "" : "es"}`
                    : ""}
                  {r.missTotal
                    ? ` (${aLabel}: ${r.missA}, ${bLabel}: ${r.missB})`
                    : ""}
                </Box>{" "}
              </Box>
            ))} */}

            {/* {playerStats.map((r) => (
              <Box
                key={r.playerId}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  gap: 0.18,
                  bgcolor:
                    selectedPlayerId === r.playerId
                      ? teamColor(team, 0.08)
                      : "transparent",
                  borderRadius: 1,
                  px: 0.3,
                  py: 0.18,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.45,
                    minWidth: 0,
                  }}
                >
                  {renderPlayerIdentity ? (
                    renderPlayerIdentity({
                      playerId: r.playerId,
                      labelOnly: false,
                      size: 28,
                      borderRadius: 5,
                      fontSize: 11,
                    })
                  ) : (
                    <Box sx={{ fontSize: 11.5, fontWeight: 900 }}>
                      {`p${r.playerId}`}
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    fontSize: 11.5,
                    lineHeight: 1.15,
                    pl: "34px",
                    wordBreak: "break-word",
                  }}
                >


                  <Box sx={{ opacity: 0.82 }}>
                    Missed {aLabel.toLowerCase()}s: {r.missA}
                  </Box>
                  <Box sx={{ opacity: 0.82 }}>
                    Missed {bLabel.toLowerCase()}s: {r.missB}
                  </Box>
                </Box>
              </Box>
            ))} */}

            {/* {playerStats.map((r) => (
              <Box
                key={r.playerId}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 0.55,
                  bgcolor:
                    selectedPlayerId === r.playerId
                      ? teamColor(team, 0.08)
                      : "transparent",
                  borderRadius: 1,
                  px: 0.3,
                  py: 0.24,
                }}
              >
                <Box
                  sx={{
                    flex: "0 0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 28,
                  }}
                >
                  {renderPlayerIdentity ? (
                    renderPlayerIdentity({
                      playerId: r.playerId,
                      labelOnly: false,
                      size: 28,
                      borderRadius: 5,
                      fontSize: 11,
                    })
                  ) : (
                    <Box sx={{ fontSize: 11.5, fontWeight: 900 }}>
                      {`p${r.playerId}`}
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    fontSize: 11.5,
                    lineHeight: 1.15,
                  }}
                >
                  <Box>
                    Missed {aLabel.toLowerCase()}s: {r.missA} 
                  </Box>
                  <Box>
                    Missed {bLabel.toLowerCase()}s: {r.missB}
                  </Box>
                </Box>
              </Box>
            ))} */}

            {playerStats.map((r) => {
              const hitAForPlayer = playerHitA(r.playerId);
              const hitBForPlayer = playerHitB(r.playerId);

              return (
                <Box
                  key={r.playerId}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 0.55,
                    bgcolor:
                      selectedPlayerId === r.playerId
                        ? teamColor(team, 0.08)
                        : "transparent",
                    borderRadius: 1,
                    px: 0.3,
                    py: 0.24,
                  }}
                >
                  <Box
                    sx={{
                      flex: "0 0 auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: 28,
                    }}
                  >
                    {renderPlayerIdentity ? (
                      renderPlayerIdentity({
                        playerId: r.playerId,
                        labelOnly: false,
                        size: 28,
                        borderRadius: 5,
                        fontSize: 11,
                      })
                    ) : (
                      <Box sx={{ fontSize: 11.5, fontWeight: 900 }}>
                        {`p${r.playerId}`}
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      minWidth: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      fontSize: 11.5,
                      lineHeight: 1.15,
                    }}
                  >
                    <Box>
                      {aLabel}s: {hitAForPlayer} (missed {r.missA})
                    </Box>
                    <Box>
                      {bLabel}s: {hitBForPlayer} (missed {r.missB})
                    </Box>
                  </Box>
                </Box>
              );
            })}

            
          </Box>
        </Box>
      )}
    </Box>
  );
}

function mphOpacity(mph?: number) {
  if (!mph || !Number.isFinite(mph)) return 0.25;
  if (mph < 30) return 0.25;
  if (mph < 45) return 0.45;
  if (mph < 60) return 0.65;
  return 0.85;
}

function expectedRiskRewardHitterTeamForRow(
  mode: ServeReturnPopupMode,
  row: KitchenArrivalRow,
): Team01 | null {
  if (row.servingTeam !== 0 && row.servingTeam !== 1) return null;
  return mode === "serve_return" ? row.servingTeam : otherTeam(row.servingTeam);
}

function expectedServePlayerIdFromServerNumber(
  row: KitchenArrivalRow,
  playerIdToTeam: (playerId: number | null) => Team01 | null,
): number | null {
  if (row.servingTeam !== 0 && row.servingTeam !== 1) return null;
  if (row.serverNumber !== 1 && row.serverNumber !== 2) return null;
  const playerIds = [0, 1, 2, 3].filter(
    (playerId) => playerIdToTeam(playerId) === row.servingTeam,
  );
  return playerIds.sort((a, b) => a - b)[row.serverNumber - 1] ?? null;
}

function extractPairPoints(args: {
  mode: ServeReturnPopupMode;
  rows: KitchenArrivalRow[];
  playerIdToTeam: (playerId: number | null) => Team01 | null;
  enforceServingTeam?: boolean;
  //fromShotNumber: number;
  // shotB: number;
}): PairPoint[] {
  // fromShotNumber
  const { mode, rows, playerIdToTeam } = args;
  const out: PairPoint[] = [];

  const fromShotNumber = mode === "serve_return" ? 1 : 2;
  const toShotNumber = mode === "serve_return" ? 2 : 3;

  for (const r of rows) {
    const a: ShotNumberOverlay | undefined = r.shotNumberOverlays?.find(
      (s: ShotNumberOverlay) => s.shotNumber === fromShotNumber,
    );
    const b: ShotNumberOverlay | undefined = r.shotNumberOverlays?.find(
      (s: ShotNumberOverlay) => s.shotNumber === toShotNumber,
    );
    // if (!a || !b) continue;
    if (!a) continue;

    const hitterTeam = playerIdToTeam(
      typeof a.playerId === "number" ? a.playerId : null,
    );
    if (hitterTeam == null) continue;

    if (args.enforceServingTeam) {
      const expectedHitterTeam = expectedRiskRewardHitterTeamForRow(mode, r);
      if (expectedHitterTeam == null || hitterTeam !== expectedHitterTeam) {
        continue;
      }
      if (mode === "serve_return" && typeof a.playerId === "number") {
        const expectedServePlayerId = expectedServePlayerIdFromServerNumber(
          r,
          playerIdToTeam,
        );
        if (
          expectedServePlayerId != null &&
          a.playerId !== expectedServePlayerId
        ) {
          continue;
        }
      }
    }

    // const locA = a.trajectoryStart?.location ?? null;
    // const locB = b?.trajectoryStart?.location ?? null;

    const locA =
      a.trajectoryStart?.location ??
      a.rawShot?.resulting_ball_movement?.trajectory?.start?.location ??
      a.rawShot?.resulting_ball_movement?.trajectory?.end?.location ??
      null;

    const locB =
      b?.trajectoryStart?.location ??
      b?.rawShot?.resulting_ball_movement?.trajectory?.start?.location ??
      b?.rawShot?.resulting_ball_movement?.trajectory?.end?.location ??
      null;

    const endLocA =
      a.rawShot?.resulting_ball_movement?.trajectory?.end?.location ?? null;
    const landingDepthFromOpponentBaselineRaw = (a.rawShot as any)
      ?.resulting_ball_movement?.distance_from_baseline;

    const ax = (locA as any)?.x;
    const ay = (locA as any)?.y;
    const bx = (locB as any)?.x;
    const by = (locB as any)?.y;
    const endX = (endLocA as any)?.x;
    const endY = (endLocA as any)?.y;

    if (!Number.isFinite(ax) || !Number.isFinite(ay)) {
      continue;
    }

    const hasB = Number.isFinite(bx) && Number.isFinite(by);

    const mph =
      (a as any)?.mph ??
      (a as any)?.speedMph ??
      (a as any)?.ballSpeedMph ??
      (a as any)?.ball_speed_mph ??
      (a as any)?.rawShot?.resulting_ball_movement?.speed ??
      undefined;

    const title =
      mode === "serve_return"
        ? "Serve Contact → Return Contact Locations"
        : "Return Contact → 3rd Shot Contact Locations";

    const fromLabel =
      mode === "serve_return" ? "Serve Contact" : "Return Contact";
    const toLabel =
      mode === "serve_return" ? "Return Contact" : "3rd Shot Contact";

    // missed “from” contact rule (your definition)
    const missFromIfMaxShotLeq = mode === "serve_return" ? 1 : 2; // serve miss => only 1 shot; return miss => only 2 shots

    // const missedShot =
    //   r.shotNumberOverlays![missFromIfMaxShotLeq].rawShot?.is_final === true;

    // const aIsFinal = a.rawShot?.is_final === true;
    // const lostOnShotA =
    //   aIsFinal && r.winnerTeam != null && r.winnerTeam !== hitterTeam;
    // const missedShot = lostOnShotA;

    const aIsFinal = a.rawShot?.is_final === true;
    const bIsFinal = b?.rawShot?.is_final === true;

    const lostOnShotA =
      aIsFinal && r.winnerTeam != null && r.winnerTeam !== hitterTeam;

    const lostOnShotB =
      bIsFinal && r.winnerTeam != null && r.winnerTeam === hitterTeam;

    const missA = lostOnShotA;
    const missB = lostOnShotB;

    // const shotCount = r.shotNumberOverlays?.length ?? undefined;
    // const missA =
    //   (fromShotNumber === 1 && shotCount <= 1) || (fromShotNumber === 2 && shotCount <= 2);

    const maxShot = r.numShots ?? 0;
    //       Math.max(
    //   0,
    //   ...(r.shotNumberOverlays ?? []).map((s: any) =>
    //     typeof s?.shotNumber === "number" ? s.shotNumber : 0,
    //   ),
    // );

    // Serve popup: miss serve => only shot 1 exists
    // Return popup: miss return => only shots 1–2 exist
    // const missA =
    //   (fromShotNumber === 1 && maxShot <= 1) || (fromShotNumber === 2 && maxShot <= 2);

    // const missA = missedShot; // maxShot <= missFromIfMaxShotLeq;

    out.push({
      rallyIndex: r.rallyIndex,
      pointKey: (r as any).pointKey ?? null,
      hitterTeam,
      hitterPlayerId: typeof a.playerId === "number" ? a.playerId : null,
      receiverPlayerId: typeof b?.playerId === "number" ? b.playerId : null,
      wonRally: r.winnerTeam == null ? null : r.winnerTeam === hitterTeam,
      ax,
      ay,
      bx: hasB ? (bx as number) : null,
      by: hasB ? (by as number) : null,
      endX: Number.isFinite(endX) ? (endX as number) : null,
      endY: Number.isFinite(endY) ? (endY as number) : null,
      landingDepthFromOpponentBaselineFt: Number.isFinite(
        landingDepthFromOpponentBaselineRaw,
      )
        ? Number(landingDepthFromOpponentBaselineRaw)
        : null,
      mph,
      winnerTeam: r.winnerTeam,
      // missA: missedShot,
      // lostOnShotA: aIsFinal && r.winnerTeam != null && r.winnerTeam !== hitterTeam,
      missA,
      missB,
      lostOnShotA,
      lostOnShotB,
      hasB,
    });
  }

  return out;
}

function CourtSvg(props: {
  team: Team01;
  points: PairPoint[];
  teamColor: (team: Team01, alpha?: number) => string;

  // mph < cutoff => very faint; above cutoff => more opaque buckets
  mphCutoff: number;

  // hover/click interactions
  // onHoverRally: (p: PairPoint | null) => void;
  onHoverRally: (
    hoverId: string | null,
    p: PairPoint | null,
    e?: React.MouseEvent<any>,
  ) => void;
  onClickRally: (p: PairPoint) => void;

  // X-axis flip (camera mirroring)
  flipX: boolean;

  viewBox: SvgViewBox;

  topLabel: string;
  bottomLabel: string;
  aIsTop: boolean;

  aLabelText: string;
  bLabelText: string;
  hoveredPoint?: PairPoint | null;
  hoveredId?: string | null;

  selectedPlayerId?: number | null;
  selectedPlayerTeam?: Team01 | null;
  renderPlayerIdentity?: RenderPlayerIdentity;

  // Auto-detect whether this team’s “A contact” y-axis is inverted (based on median ay)
  // autoFlipY: boolean;
}) {
  const {
    team,
    points,
    teamColor,
    mphCutoff,
    onHoverRally,
    onClickRally,
    flipX,
    // autoFlipY,
    viewBox,
    topLabel,
    bottomLabel,
    aIsTop,
    aLabelText,
    bLabelText,
    hoveredPoint,
    hoveredId,
    selectedPlayerId = null,
    selectedPlayerTeam = null,
    renderPlayerIdentity,
  } = props;

  const topTeamId: Team01 = aIsTop ? team : otherTeam(team);
  const bottomTeamId: Team01 = aIsTop ? otherTeam(team) : team;

  // Space on the left for labels/arrow (SVG coords)
  const labelX = -58;
  const arrowX = -28;

  // Decide which baseline is "A contact" for this court.
  // You already know this when you pass topLabel/bottomLabel.
  // So pass an explicit flag:

  const didTeamWin = (p: PairPoint, t: Team01) =>
    p.winnerTeam != null && p.winnerTeam === t;

  // Team 0 is far side (baseline at top), Team 1 is near side (baseline at bottom)
  // const flipY = team === 0;

  // const W = 200;
  // const H = 320;
  const W = COURT_SVG_W;
  const H = COURT_SVG_H;

  const pts = points.filter((p) => p.hitterTeam === team);

  // feet -> svg coords (allowing values outside [0..20]/[0..44])
  const sx = (xFeet: number) =>
    flipX ? (1 - xFeet / 20) * W : (xFeet / 20) * W;

  // const sy = (yFeet: number) =>
  //   flipY ? (yFeet / 44) * H : (1 - yFeet / 44) * H;

  const yRel = (yAbs: number) => (team === 1 ? 44 - yAbs : yAbs);

  // Team 0 baseline at top, Team 1 baseline at bottom:
  const sy = (yAbsFeet: number) =>
    team === 0
      ? (yRel(yAbsFeet) / 44) * H // baseline (0) at top
      : (1 - yRel(yAbsFeet) / 44) * H; // baseline (0) at bottom

  const opacityFromMph = (mph?: number) => {
    if (!mph || !Number.isFinite(mph)) return 0.1;
    if (mph < mphCutoff) return 0.4;
    if (mph < mphCutoff + 8) return 0.7;
    if (mph < mphCutoff + 18) return 0.9;
    return 1;
  };

  // Expand viewBox to include out-of-bounds points (with padding) so nothing disappears.
  // const pad = 12;

  // let minX = 0;
  // let maxX = W;
  // let minY = 0;
  // let maxY = H;

  // for (const p of pts) {
  //   const ax = sx(p.ax);
  //   const ay = sy(p.ay);
  //   const bx = sx(p.bx);
  //   const by = sy(p.by);

  //   minX = Math.min(minX, ax, bx);
  //   maxX = Math.max(maxX, ax, bx);
  //   minY = Math.min(minY, ay, by);
  //   maxY = Math.max(maxY, ay, by);
  // }

  // minX -= pad;
  // maxX += pad;
  // minY -= pad;
  // maxY += pad;

  // Kitchen line offset (7ft from net)
  const k = (7 / 44) * H;
  const kitchenTop = H / 2 - k;
  const kitchenBot = H / 2 + k;

  // Center line, but skip the kitchen zone (so we don't draw a line through it)
  const centerX = W / 2;

  // dots should always be readable; keep them strong regardless of mph bucket
  const dotColor = teamColor(team, 0.92);

  // midpoint arrowhead: draw a tiny segment so markerEnd renders there too
  const midLen = 0.01; // tiny; effectively "point"
  const arrowDown = team === 0; // example
  const y1 = arrowDown ? 20 : 180;
  const y2 = arrowDown ? 180 : 20;
  const yMid = (y1 + y2) / 2;

  const dy = y2 > y1 ? midLen : -midLen;
  const yEnd = arrowDown ? y1 : y2;
  const yStart = arrowDown ? y1 : y2; //VBH;

  // little arrow at start
  const VBH = 200;
  const x = 12;

  // where the arrow should point:
  // if A is top, direction is top -> bottom. else bottom -> top.
  // const yStart = aIsTop ? 0 : VBH;
  // const yEnd = aIsTop ? VBH : 0;

  // how far "down" from the start you want the start arrowhead to appear
  const startMarkerInset = 10; // tweak this
  const yStartMarker = aIsTop
    ? yStart + startMarkerInset
    : yStart - startMarkerInset + 5;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: 0,
        border: "1px solid rgba(0,0,0,0.10)",
        bgcolor: "rgba(255,255,255,0.92)",
        overflow: "hidden",
        display: "grid",
        gridTemplateRows: "24px auto 30px",
        alignContent: "start",
      }}
    >
      <Box
        sx={{
          minHeight: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 0.6,
          pb: 0,
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          bgcolor: teamRgba(topTeamId, 0.05),
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.55,
            fontSize: 12.5,
            fontWeight: 600,
            whiteSpace: "nowrap",
            lineHeight: 1,
            transform: "translateY(0.5px)",
          }}
        >
          <Box>{`Team ${topTeamId}`}</Box>

          {selectedPlayerId != null &&
          selectedPlayerTeam === topTeamId &&
          renderPlayerIdentity
            ? renderPlayerIdentity({
                playerId: selectedPlayerId,
                labelOnly: false,
                size: 20,
                borderRadius: 4,
                fontSize: 11,
              })
            : null}

          <Box>{topLabel}</Box>
        </Box>
      </Box>

      <Box
        sx={{
          position: "relative",
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            height: "100%",
            aspectRatio: COURT_ASPECT_RATIO,
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <svg
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid meet"
            viewBox={`${viewBox.minX} ${viewBox.minY} ${viewBox.w} ${viewBox.h}`}
            onMouseLeave={() => onHoverRally(null, null)}
            style={{ display: "block" }}
          >
            {/* court bounds */}
            <line x1={0} y1={0} x2={0} y2={H} stroke="rgba(0,0,0,0.12)" />
            <line x1={W} y1={0} x2={W} y2={H} stroke="rgba(0,0,0,0.12)" />
            <line x1={0} y1={0} x2={W} y2={0} stroke="rgba(0,0,0,0.12)" />
            <line x1={0} y1={H} x2={W} y2={H} stroke="rgba(0,0,0,0.12)" />

            {/* net */}
            <line
              x1={0}
              y1={H / 2}
              x2={W}
              y2={H / 2}
              stroke="rgba(0,0,0,0.12)"
            />

            {/* center line, skipping the kitchen */}
            <line
              x1={centerX}
              y1={0}
              x2={centerX}
              y2={kitchenTop}
              stroke="rgba(0,0,0,0.10)"
            />
            <line
              x1={centerX}
              y1={kitchenBot}
              x2={centerX}
              y2={H}
              stroke="rgba(0,0,0,0.10)"
            />

            {/* kitchen lines */}
            <line
              x1={0}
              y1={kitchenTop}
              x2={W}
              y2={kitchenTop}
              stroke="rgba(0,0,0,0.10)"
            />
            <line
              x1={0}
              y1={kitchenBot}
              x2={W}
              y2={kitchenBot}
              stroke="rgba(0,0,0,0.10)"
            />

            {pts.map((p, i) => {
              const color = teamColor(team, 0.5);
              const colorLineHovered = teamColor(team, 1);

              const ax = sx(p.ax);
              const ay = sy(p.ay);
              // const bx = sx(p.bx);
              // const by = sy(p.by);

              const bx = p.bx != null ? sx(p.bx) : null;
              const by = p.by != null ? sy(p.by) : null;

              const key = `${p.rallyIndex}-${i}`;

              const aTeam = team;
              const bTeam = otherTeam(team);

              const aWon = didTeamWin(p, aTeam);
              const bWon = didTeamWin(p, bTeam);

              const aColor = teamColor(aTeam, 0.92);
              const bColor = teamColor(bTeam, 0.92);

              const id = `${p.rallyIndex}-${i}`;
              const isHovered = hoveredId === id;

              const dotR = isHovered ? 5.6 : 4.2;
              const dotStrokeW = isHovered ? 3 : 2;

              return (
                <g
                  key={key}
                  style={{ cursor: "pointer" }}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickRally(p);
                  }}
                >
                  {p.hasB && bx != null && by != null ? (
                    isHovered ? (
                      <line
                        x1={ax}
                        y1={ay}
                        x2={bx}
                        y2={by}
                        stroke={colorLineHovered}
                        strokeWidth={4}
                      />
                    ) : (
                      <line
                        x1={ax}
                        y1={ay}
                        x2={bx}
                        y2={by}
                        stroke={color}
                        strokeWidth={2.6}
                        strokeDasharray="2 3"
                        pointerEvents="none"
                      />
                    )
                  ) : null}

                  {isHovered && (
                    <circle
                      cx={ax}
                      cy={ay}
                      r={dotR + 3}
                      fill="none"
                      stroke={aColor}
                      strokeWidth={2}
                      opacity={0.18}
                      pointerEvents="none"
                    />
                  )}

                  {p.lostOnShotA && (
                    <circle
                      cx={ax}
                      cy={ay}
                      r={dotR + 4.6}
                      fill="none"
                      stroke="rgba(220, 38, 38, 0.95)"
                      strokeWidth={2.4}
                      pointerEvents="none"
                    />
                  )}
                  <circle
                    data-demo="shot-location-point"
                    cx={ax}
                    cy={ay}
                    r={dotR}
                    fill={aWon ? aColor : "transparent"}
                    stroke={aColor}
                    strokeWidth={aWon ? 0 : dotStrokeW}
                    pointerEvents="all"
                    onMouseEnter={(e) => onHoverRally(id, p, e)}
                    onMouseLeave={() => onHoverRally(null, null)}
                  />

                  {p.hasB && bx != null && by != null ? (
                    <>
                      {isHovered && (
                        <circle
                          cx={bx}
                          cy={by}
                          r={dotR + 3}
                          fill="none"
                          stroke={bColor}
                          strokeWidth={4}
                          opacity={0.18}
                          pointerEvents="none"
                        />
                      )}

                      {p.lostOnShotB && (
                        <circle
                          cx={bx}
                          cy={by}
                          r={dotR + 4.6}
                          fill="none"
                          stroke="rgba(220, 38, 38, 0.95)"
                          strokeWidth={2.4}
                          pointerEvents="none"
                        />
                      )}

                      <circle
                        data-demo="shot-location-point"
                        cx={bx}
                        cy={by}
                        r={dotR}
                        fill={bWon ? bColor : "transparent"}
                        stroke={bColor}
                        strokeWidth={bWon ? 0 : dotStrokeW}
                        pointerEvents="all"
                        onMouseEnter={(e) => onHoverRally(id, p, e)}
                        onMouseLeave={() => onHoverRally(null, null)}
                      />

                      {p.lostOnShotB && (
                        <>
                          <line
                            x1={bx - 4.8}
                            y1={by - 4.8}
                            x2={bx + 4.8}
                            y2={by + 4.8}
                            stroke="black"
                            strokeWidth={2.2}
                            pointerEvents="none"
                          />
                          <line
                            x1={bx - 4.8}
                            y1={by + 4.8}
                            x2={bx + 4.8}
                            y2={by - 4.8}
                            stroke="black"
                            strokeWidth={2.2}
                            pointerEvents="none"
                          />
                        </>
                      )}
                    </>
                  ) : null}

                  {p.lostOnShotA ? (
                    <>
                      <line
                        x1={ax - 4.8}
                        y1={ay - 4.8}
                        x2={ax + 4.8}
                        y2={ay + 4.8}
                        stroke="black"
                        strokeWidth={2.2}
                        pointerEvents="none"
                      />
                      <line
                        x1={ax - 4.8}
                        y1={ay + 4.8}
                        x2={ax + 4.8}
                        y2={ay - 4.8}
                        stroke="black"
                        strokeWidth={2.2}
                        pointerEvents="none"
                      />
                    </>
                  ) : null}
                </g>
              );
            })}
          </svg>
        </Box>
      </Box>

      <Box
        sx={{
          minHeight: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 0.6,
          pt: 0,
          pb: 0.55,
          borderTop: "1px solid rgba(0,0,0,0.08)",
          bgcolor: teamRgba(bottomTeamId, 0.05),
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.55,
            fontSize: 12.5,
            fontWeight: 600,
            whiteSpace: "nowrap",
            lineHeight: 1,
            transform: "translateY(-1px)",
          }}
        >
          <Box>{`Team ${bottomTeamId}`}</Box>

          {selectedPlayerId != null &&
          selectedPlayerTeam === bottomTeamId &&
          renderPlayerIdentity
            ? renderPlayerIdentity({
                playerId: selectedPlayerId,
                labelOnly: false,
                size: 20,
                borderRadius: 4,
                fontSize: 11,
              })
            : null}

          <Box>{bottomLabel}</Box>
        </Box>
      </Box>
    </Box>
  );
}

export function ServeLocationsPopup(props: {
  insightsToCvPlayerIndex: PlayerIndexMap;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;

  packageId: string;
  rows: KitchenArrivalRow[];
  playerIdToTeam: (playerId: number | null) => 0 | 1 | null;
  teamColor: (team: 0 | 1, alpha?: number) => string;
  renderPlayerIdentity: RenderPlayerIdentity;

  popupW_VideoPart: string | number;
  popupH_VideoPart: string | number;

  firefightsClips?: FirefightClip[];
  firefightRallySet?: Set<number>;
}) {
  return (
    <ServeReturnBase
      {...props}
      title="Serve Contact → Return Contact"
      mode="serve_return"
      // fromShotNumber={1}
      // shotB={2}
      activeShotNumberForVideo={1}
      aLabel="Serve"
      bLabel="Return"
    />
  );
}

export function ReturnLocationsPopup(props: {
  insightsToCvPlayerIndex: PlayerIndexMap;
  renderPlayerIdentity: RenderPlayerIdentity;

  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;

  packageId: string;
  rows: KitchenArrivalRow[];
  playerIdToTeam: (playerId: number | null) => 0 | 1 | null;
  teamColor: (team: 0 | 1, alpha?: number) => string;
  popupW_VideoPart: string | number;
  popupH_VideoPart: string | number;

  firefightsClips?: FirefightClip[];
  firefightRallySet?: Set<number>;
}) {
  return (
    <ServeReturnBase
      {...props}
      title="Return Contact → 3rd Shot Contact"
      mode="return_third"
      // fromShotNumber={2}
      // shotB={3}
      activeShotNumberForVideo={2}
      aLabel="Return"
      bLabel="3rd Shot"
    />
  );
}

type RiskRewardMode = "serve" | "return";

function finiteOrNull(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

function pairPointSpeedMph(p: PairPoint): number | null {
  return finiteOrNull(p.mph);
}

function pairPointLandingDepthFromOpponentBaseline(p: PairPoint): number | null {
  if (p.lostOnShotA) return null;
  return finiteOrNull(p.landingDepthFromOpponentBaselineFt);
}

function riskRewardActorPlayerId(p: PairPoint): number | null {
  return typeof p.hitterPlayerId === "number" ? p.hitterPlayerId : null;
}

function pairPointAngleDeg(p: PairPoint): number | null {
  const targetX = p.endX ?? p.bx;
  const targetY = p.endY ?? p.by;
  if (targetX == null || targetY == null) return null;
  const dx = Math.abs(targetX - p.ax);
  const dy = Math.abs(targetY - p.ay);
  if (!Number.isFinite(dx) || !Number.isFinite(dy) || (dx === 0 && dy === 0)) {
    return null;
  }
  return (Math.atan2(dx, Math.max(0.01, dy)) * 180) / Math.PI;
}

function riskRewardPointId(p: PairPoint): string {
  return `${p.rallyIndex}-${p.pointKey ?? "x"}-${riskRewardActorPlayerId(p) ?? "p"}`;
}

function riskRewardPlayerRoleLabel(mode: RiskRewardMode): string {
  return mode === "serve" ? "Server focus" : "Returner focus";
}

function riskRewardActionLabel(mode: RiskRewardMode): string {
  return mode === "serve" ? "serve" : "return";
}

function riskRewardPositiveOutcomeLabel(mode: RiskRewardMode): string {
  return mode === "serve" ? "Serving side won rally" : "Return side won rally";
}

function riskRewardNegativeOutcomeLabel(mode: RiskRewardMode): string {
  return mode === "serve" ? "Serving side lost rally" : "Serving side won rally";
}

function riskRewardRateLabel(mode: RiskRewardMode): string {
  return mode === "serve" ? "Serve rally win rate" : "Return-side win rate";
}

function riskRewardEndedOnShotLabel(mode: RiskRewardMode): string {
  return mode === "serve" ? "Serve ended point" : "Return ended point";
}

function riskRewardOutcomeLabel(mode: RiskRewardMode, p: PairPoint): string {
  return p.wonRally
    ? riskRewardPositiveOutcomeLabel(mode)
    : riskRewardNegativeOutcomeLabel(mode);
}

function riskRewardPct(count: number, total: number): number | null {
  return total > 0 ? Math.round((count / total) * 100) : null;
}

function rangeFromValues(
  values: Array<number | null>,
  fallback: [number, number],
): [number, number] {
  const finite = values.filter(
    (v): v is number => typeof v === "number" && Number.isFinite(v),
  );
  if (!finite.length) return fallback;
  const min = Math.floor(Math.min(...finite));
  const max = Math.ceil(Math.max(...finite));
  if (min === max) return [Math.max(0, min - 1), max + 1] as [number, number];
  return [min, max] as [number, number];
}

function RiskRewardCourtPlot(props: {
  mode: RiskRewardMode;
  points: PairPoint[];
  selectedPoint: PairPoint | null;
  selectedPlayerId: number | null;
  selectedPlayerTeam: Team01 | null;
  teamColor: (team: Team01, alpha?: number) => string;
  renderPlayerIdentity: RenderPlayerIdentity;
  onSelect: (p: PairPoint) => void;
}) {
  const {
    mode,
    points,
    selectedPlayerId,
    selectedPlayerTeam,
    teamColor,
    renderPlayerIdentity,
    onSelect,
  } = props;
  const aLabel = mode === "serve" ? "Serve" : "Return";
  const bLabel = mode === "serve" ? "Return" : "3rd Shot";
  const mphCutoff = mode === "serve" ? 35 : 28;
  const courtPad = 24;
  const fullCourtViewBox: SvgViewBox = {
    minX: -courtPad,
    minY: -courtPad,
    w: COURT_SVG_W + courtPad * 2,
    h: COURT_SVG_H + courtPad * 2,
  };
  const noopHover = React.useCallback(() => {}, []);
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 0.75,
        height: "100%",
        minHeight: 0,
      }}
    >
      <Box sx={{ minHeight: 0 }}>
        <CourtSvg
          team={0}
          topLabel={`Team 0 ${aLabel} Contact`}
          bottomLabel={`Team 1 ${bLabel} Contact`}
          aLabelText={`${aLabel} Contact`}
          bLabelText={`${bLabel} Contact`}
          aIsTop={true}
          points={points}
          teamColor={teamColor}
          mphCutoff={mphCutoff}
          onHoverRally={noopHover}
          onClickRally={onSelect}
          flipX={false}
          viewBox={fullCourtViewBox}
          selectedPlayerId={selectedPlayerId}
          selectedPlayerTeam={selectedPlayerTeam}
          renderPlayerIdentity={renderPlayerIdentity}
        />
      </Box>
      <Box sx={{ minHeight: 0 }}>
        <CourtSvg
          team={1}
          topLabel={`Team 0 ${bLabel} Contact`}
          bottomLabel={`Team 1 ${aLabel} Contact`}
          aLabelText={`${aLabel} Contact`}
          bLabelText={`${bLabel} Contact`}
          aIsTop={false}
          points={points}
          teamColor={teamColor}
          mphCutoff={mphCutoff}
          onHoverRally={noopHover}
          onClickRally={onSelect}
          flipX={false}
          viewBox={fullCourtViewBox}
          selectedPlayerId={selectedPlayerId}
          selectedPlayerTeam={selectedPlayerTeam}
          renderPlayerIdentity={renderPlayerIdentity}
        />
      </Box>
    </Box>
  );
}

function RiskRewardSlider(props: {
  label: string;
  value: [number, number];
  min: number;
  max: number;
  unit: string;
  onChange: (value: [number, number]) => void;
  dataDemo?: string;
}) {
  const { label, value, min, max, unit, onChange, dataDemo } = props;
  return (
    <Box sx={{ px: 1, py: 0.5 }} data-demo={dataDemo}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 1,
          fontSize: 12,
          fontWeight: 800,
        }}
      >
        <span>{label}</span>
        <span>
          {value[0]}-{value[1]} {unit}
        </span>
      </Box>
      <Slider
        value={value}
        min={min}
        max={max}
        size="small"
        onChange={(_, next) => {
          if (Array.isArray(next) && next.length === 2) {
            onChange([Number(next[0]), Number(next[1])]);
          }
        }}
      />
    </Box>
  );
}

export function ServeReturnRiskRewardPopup(props: {
  insightsToCvPlayerIndex: PlayerIndexMap;
  renderPlayerIdentity: RenderPlayerIdentity;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  packageId: string;
  rows: KitchenArrivalRow[];
  playerIdToTeam: (playerId: number | null) => 0 | 1 | null;
  teamColor: (team: 0 | 1, alpha?: number) => string;
  firefightsClips?: FirefightClip[];
  firefightRallySet?: Set<number>;
}) {
  const {
    open,
    onClose,
    packageId,
    rows,
    playerIdToTeam,
    teamColor,
    renderPlayerIdentity,
    insightsToCvPlayerIndex,
    firefightsClips,
    firefightRallySet,
  } = props;

  const [rect, setRect] = React.useState<FloatingRect>(() => ({
    x: 24,
    y: 42,
    w:
      typeof window === "undefined"
        ? 1420
        : Math.min(1540, Math.max(1280, window.innerWidth - 32)),
    h:
      typeof window === "undefined"
        ? 840
        : Math.min(900, Math.max(760, window.innerHeight - 48)),
  }));
  const didCenterRef = React.useRef(false);
  const [mode, setMode] = React.useState<RiskRewardMode>("serve");
  const [selectedPlayerId, setSelectedPlayerId] = React.useState<number | null>(
    null,
  );
  const [selectedPointId, setSelectedPointId] = React.useState<string | null>(
    null,
  );
  const [scanOpen, setScanOpen] = React.useState(false);
  const [scanPreviewScale, setScanPreviewScale] = React.useState<1 | 2 | 4 | 8>(
    2,
  );

  const servePoints = React.useMemo(
    () =>
      extractPairPoints({
        mode: "serve_return",
        rows,
        playerIdToTeam,
        enforceServingTeam: true,
      }),
    [rows, playerIdToTeam],
  );
  const returnPoints = React.useMemo(
    () =>
      extractPairPoints({
        mode: "return_third",
        rows,
        playerIdToTeam,
        enforceServingTeam: true,
      }),
    [rows, playerIdToTeam],
  );
  const points = mode === "serve" ? servePoints : returnPoints;

  const speedBounds = React.useMemo(
    () =>
      rangeFromValues(
        points.map(pairPointSpeedMph),
        mode === "serve" ? [0, 70] : [0, 55],
      ),
    [mode, points],
  );
  const depthBounds = React.useMemo(
    () =>
      rangeFromValues(
        points.map(pairPointLandingDepthFromOpponentBaseline),
        [0, 44],
      ),
    [points],
  );
  const angleBounds = React.useMemo(
    () => rangeFromValues(points.map(pairPointAngleDeg), [0, 50]),
    [points],
  );

  const [speedRange, setSpeedRange] = React.useState<[number, number]>([0, 70]);
  const [depthRange, setDepthRange] = React.useState<[number, number]>([0, 44]);
  const [angleRange, setAngleRange] = React.useState<[number, number]>([0, 50]);

  React.useEffect(() => {
    setSpeedRange(speedBounds);
    setDepthRange(depthBounds);
    setAngleRange(angleBounds);
    setSelectedPointId(null);
    setSelectedPlayerId(null);
  }, [mode, speedBounds, depthBounds, angleBounds]);

  React.useEffect(() => {
    if (!open) {
      didCenterRef.current = false;
      return;
    }
    if (didCenterRef.current) return;
    const x = Math.max(8, Math.floor((window.innerWidth - rect.w) / 2));
    const y = Math.max(8, Math.floor((window.innerHeight - rect.h) / 2));
    setRect({ ...rect, x, y });
    didCenterRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const playerIds = React.useMemo(() => {
    const seen = new Set<number>();
    for (const p of points) {
      const actorPlayerId = riskRewardActorPlayerId(p);
      if (actorPlayerId != null) seen.add(actorPlayerId);
    }
    return Array.from(seen).sort((a, b) => a - b);
  }, [points]);

  React.useEffect(() => {
    if (selectedPlayerId == null) return;
    if (!playerIds.includes(selectedPlayerId)) setSelectedPlayerId(null);
  }, [playerIds, selectedPlayerId]);

  React.useEffect(() => {
    setSelectedPointId(null);
  }, [selectedPlayerId]);

  const selectedPlayerTeam = React.useMemo(
    () => (selectedPlayerId == null ? null : playerIdToTeam(selectedPlayerId)),
    [playerIdToTeam, selectedPlayerId],
  );

  const filteredPoints = React.useMemo(
    () =>
      points.filter((p) => {
        if (
          selectedPlayerId != null &&
          riskRewardActorPlayerId(p) !== selectedPlayerId
        ) {
          return false;
        }
        const speed = pairPointSpeedMph(p);
        if (speed != null && (speed < speedRange[0] || speed > speedRange[1])) {
          return false;
        }
        const angle = pairPointAngleDeg(p);
        if (angle != null && (angle < angleRange[0] || angle > angleRange[1])) {
          return false;
        }
        const depth = pairPointLandingDepthFromOpponentBaseline(p);
        if (
          depth != null &&
          !p.lostOnShotA &&
          (depth < depthRange[0] || depth > depthRange[1])
        ) {
          return false;
        }
        return true;
      }),
    [angleRange, depthRange, points, selectedPlayerId, speedRange],
  );

  const selectedPoint = React.useMemo(() => {
    if (selectedPointId == null) return filteredPoints[0] ?? null;
    return (
      filteredPoints.find((p) => riskRewardPointId(p) === selectedPointId) ??
      filteredPoints[0] ??
      null
    );
  }, [filteredPoints, selectedPointId]);

  const rowByRallyIndex = React.useMemo(() => {
    const m = new Map<number, KitchenArrivalRow>();
    for (const r of rows) m.set(r.rallyIndex, r);
    return m;
  }, [rows]);
  const selectedRow =
    selectedPoint == null
      ? null
      : rowByRallyIndex.get(selectedPoint.rallyIndex) ?? null;

  const rewardCount = filteredPoints.filter((p) => p.wonRally === true).length;
  const riskCount = filteredPoints.filter((p) => p.wonRally === false).length;
  const missCount = filteredPoints.filter((p) => p.lostOnShotA).length;
  const positiveOutcomeLabel = riskRewardPositiveOutcomeLabel(mode);
  const negativeOutcomeLabel = riskRewardNegativeOutcomeLabel(mode);
  const rateLabel = riskRewardRateLabel(mode);
  const endedOnShotLabel = riskRewardEndedOnShotLabel(mode);
  const rewardPct = riskRewardPct(rewardCount, filteredPoints.length) ?? 0;
  const showPlayerStats = selectedPlayerId != null;
  const selectedPlayerAllPoints = React.useMemo(
    () =>
      selectedPlayerId == null
        ? []
        : points.filter((p) => riskRewardActorPlayerId(p) === selectedPlayerId),
    [points, selectedPlayerId],
  );
  const baselineWonCount = selectedPlayerAllPoints.filter(
    (p) => p.wonRally === true,
  ).length;
  const baselinePct = riskRewardPct(
    baselineWonCount,
    selectedPlayerAllPoints.length,
  );
  const liftPct =
    showPlayerStats && baselinePct != null ? rewardPct - baselinePct : null;
  const settingsSummary = [
    `${mode === "serve" ? "Serve" : "Return"} focus`,
    selectedPlayerId == null ? "All players" : `player ${selectedPlayerId}`,
    `${Math.round(speedRange[0])}-${Math.round(speedRange[1])} mph`,
    `${Math.round(depthRange[0])}-${Math.round(depthRange[1])} ft from opponent baseline`,
    `${Math.round(angleRange[0])}-${Math.round(angleRange[1])} deg`,
  ].join(" · ");

  const selectedPointDetails = selectedPoint
    ? [
        pairPointSpeedMph(selectedPoint) == null
          ? "pace n/a"
          : `${Math.round(pairPointSpeedMph(selectedPoint)!)} mph`,
        pairPointLandingDepthFromOpponentBaseline(selectedPoint) == null
          ? "landing depth ignored"
          : `${pairPointLandingDepthFromOpponentBaseline(selectedPoint)!.toFixed(
              1,
            )} ft from opponent baseline`,
        pairPointAngleDeg(selectedPoint) == null
          ? "angle n/a"
          : `${Math.round(pairPointAngleDeg(selectedPoint)!)} deg`,
        riskRewardOutcomeLabel(mode, selectedPoint),
      ].join(" · ")
    : "";

  if (!open) return null;

  return (
    <>
    <FloatingPanel
      open={open}
      rect={rect}
      onChangeRect={setRect}
      onClose={onClose}
      title="Serve / Return Outcome Review"
      minW={1160}
      minH={680}
      color="black"
      dataDemo="serve-return-risk-reward-popup"
    >
      <Box
        sx={{
          height: "100%",
          display: "grid",
          gridTemplateColumns: "270px minmax(360px, 480px) minmax(470px, 1fr)",
          gap: 1,
          p: 1,
          bgcolor: "#f8fafc",
          color: "#0f172a",
          overflow: "hidden",
        }}
        data-happy-path="serveReturnRisk-popup"
        data-demo="serve-return-risk-reward-popup"
      >
        <Box
          sx={{ display: "flex", flexDirection: "column", gap: 1, minHeight: 0 }}
        >
          <Box sx={{ display: "flex", gap: 0.75 }} data-demo="risk-reward-mode-tabs">
            {(["serve", "return"] as RiskRewardMode[]).map((nextMode) => (
              <Button
                key={nextMode}
                size="small"
                variant={mode === nextMode ? "contained" : "outlined"}
                onClick={() => {
                  setMode(nextMode);
                  setSelectedPlayerId(null);
                  setSelectedPointId(null);
                }}
                sx={{ textTransform: "none", fontWeight: 900 }}
              >
                {nextMode === "serve" ? "Serves" : "Returns"}
              </Button>
            ))}
          </Box>

          <Box
            sx={{
              border: "1px solid rgba(15,23,42,0.14)",
              borderRadius: 1,
              bgcolor: "white",
              p: 1,
            }}
            data-demo="risk-reward-player-focus"
          >
            <Box sx={{ fontWeight: 900, mb: 0.75 }}>
              {riskRewardPlayerRoleLabel(mode)}
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.65 }}>
              <Button
                size="small"
                variant={selectedPlayerId == null ? "contained" : "outlined"}
                onClick={() => {
                  setSelectedPlayerId(null);
                  setSelectedPointId(null);
                }}
                sx={{ textTransform: "none", fontWeight: 900 }}
              >
                All
              </Button>
              {playerIds.map((pid) => (
                <Button
                  key={pid}
                  size="small"
                  variant={selectedPlayerId === pid ? "contained" : "outlined"}
                  onClick={() => {
                    setSelectedPlayerId(pid);
                    setSelectedPointId(null);
                  }}
                  sx={{
                    textTransform: "none",
                    fontWeight: 900,
                    minWidth: 0,
                    px: 0.8,
                    display: "inline-flex",
                    gap: 0.5,
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 950 }}>p{pid}</span>
                  {renderPlayerIdentity({
                    playerId: pid,
                    avatarOnly: true,
                    size: 30,
                    borderRadius: 5,
                    fontSize: 11,
                  })}
                </Button>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              border: "1px solid rgba(15,23,42,0.14)",
              borderRadius: 1,
              bgcolor: "white",
              p: 0.5,
            }}
          >
            <RiskRewardSlider
              label="Pace"
              value={speedRange}
              min={speedBounds[0]}
              max={speedBounds[1]}
              unit="mph"
              onChange={setSpeedRange}
              dataDemo="risk-reward-pace-slider"
            />
            <RiskRewardSlider
              label={`${
                mode === "serve" ? "Serve" : "Return"
              } landing depth from opponent baseline`}
              value={depthRange}
              min={depthBounds[0]}
              max={depthBounds[1]}
              unit="ft"
              onChange={setDepthRange}
              dataDemo="risk-reward-depth-slider"
            />
            <Box
              sx={{
                px: 1,
                mt: -0.75,
                mb: 0.25,
                fontSize: 11,
                color: "rgba(15,23,42,0.65)",
              }}
            >
              Depth is measured from the opponent baseline to the{" "}
              {riskRewardActionLabel(mode)} landing point. Out/net balls ignore
              landing depth. Locations, depth, and angle are estimated from
              tracked data.
            </Box>
            <RiskRewardSlider
              label="Angle"
              value={angleRange}
              min={angleBounds[0]}
              max={angleBounds[1]}
              unit="deg"
              onChange={setAngleRange}
              dataDemo="risk-reward-angle-slider"
            />
          </Box>

          {showPlayerStats ? (
            <>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 0.75,
                }}
                data-demo="risk-reward-summary-stats"
              >
                <Box sx={{ p: 1, borderRadius: 1, bgcolor: "rgba(34,197,94,0.12)" }}>
                  <Box sx={{ fontSize: 12, fontWeight: 900 }}>{positiveOutcomeLabel}</Box>
                  <Box sx={{ fontSize: 28, fontWeight: 900 }}>{rewardCount}</Box>
                </Box>
                <Box sx={{ p: 1, borderRadius: 1, bgcolor: "rgba(239,68,68,0.11)" }}>
                  <Box sx={{ fontSize: 12, fontWeight: 900 }}>{negativeOutcomeLabel}</Box>
                  <Box sx={{ fontSize: 28, fontWeight: 900 }}>{riskCount}</Box>
                </Box>
                <Box sx={{ p: 1, borderRadius: 1, bgcolor: "rgba(59,130,246,0.10)" }}>
                  <Box sx={{ fontSize: 12, fontWeight: 900 }}>{rateLabel}</Box>
                  <Box sx={{ fontSize: 24, fontWeight: 900 }}>{rewardPct}%</Box>
                </Box>
                <Box sx={{ p: 1, borderRadius: 1, bgcolor: "rgba(245,158,11,0.12)" }}>
                  <Box sx={{ fontSize: 12, fontWeight: 900 }}>{endedOnShotLabel}</Box>
                  <Box sx={{ fontSize: 24, fontWeight: 900 }}>{missCount}</Box>
                </Box>
              </Box>
              <Box
                sx={{
                  p: 0.85,
                  borderRadius: 1,
                  bgcolor: "rgba(15,23,42,0.05)",
                  border: "1px solid rgba(15,23,42,0.10)",
                  fontSize: 11.5,
                }}
              >
                <Box sx={{ fontWeight: 900 }}>
                  Filtered slice: {filteredPoints.length} clips · {rewardPct}%
                </Box>
                <Box sx={{ color: "rgba(15,23,42,0.68)", mt: 0.25 }}>
                  Player baseline: {selectedPlayerAllPoints.length} clips ·{" "}
                  {baselinePct == null ? "n/a" : `${baselinePct}%`}
                  {liftPct == null
                    ? ""
                    : ` · ${liftPct >= 0 ? "+" : ""}${liftPct} pts vs baseline`}
                </Box>
              </Box>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setScanOpen(true)}
                data-demo="risk-reward-scan-all"
                sx={{ textTransform: "none", fontWeight: 900 }}
              >
                Scan filtered clips
              </Button>
            </>
          ) : (
            <Box
              sx={{
                p: 1,
                borderRadius: 1,
                bgcolor: "rgba(15,23,42,0.05)",
                color: "rgba(15,23,42,0.68)",
                fontSize: 12,
                fontWeight: 750,
              }}
              data-demo="risk-reward-summary-stats"
            >
              Select a player to show outcome totals. The all-player view is
              useful for finding ranges, but the summary rate is only shown when
              the actor is specific.
            </Box>
          )}
        </Box>

        <Box
          sx={{ minHeight: 0, display: "flex", flexDirection: "column", gap: 1 }}
        >
          <Box>
            <Box sx={{ fontWeight: 900 }}>
              {filteredPoints.length}/{points.length}{" "}
              {mode === "serve" ? "serves" : "returns"} match filters
            </Box>
            <Box sx={{ mt: 0.15, fontSize: 11, color: "rgba(15,23,42,0.62)" }}>
              Court locations, depth, and angle are estimated from tracked data.
            </Box>
          </Box>
          <Box sx={{ flex: "0 0 410px", minHeight: 0 }} data-demo="risk-reward-court-plot">
            <RiskRewardCourtPlot
              mode={mode}
              points={filteredPoints}
              selectedPoint={selectedPoint}
              selectedPlayerId={selectedPlayerId}
              selectedPlayerTeam={selectedPlayerTeam}
              teamColor={teamColor}
              renderPlayerIdentity={renderPlayerIdentity}
              onSelect={(p) => setSelectedPointId(riskRewardPointId(p))}
            />
          </Box>
          <Box
            sx={{
              minHeight: 0,
              overflow: "auto",
              border: "1px solid rgba(15,23,42,0.14)",
              borderRadius: 1,
              bgcolor: "white",
            }}
            data-demo="risk-reward-result-list"
          >
            {filteredPoints.slice(0, 80).map((p) => {
              const selected =
                selectedPoint &&
                riskRewardPointId(selectedPoint) === riskRewardPointId(p);
              const speed = pairPointSpeedMph(p);
              const depth = pairPointLandingDepthFromOpponentBaseline(p);
              const angle = pairPointAngleDeg(p);
              return (
                <Box
                  key={riskRewardPointId(p)}
                  onClick={() => setSelectedPointId(riskRewardPointId(p))}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "68px 1fr 74px",
                    gap: 1,
                    alignItems: "center",
                    p: 0.85,
                    cursor: "pointer",
                    bgcolor: selected ? "rgba(59,130,246,0.14)" : "white",
                    borderBottom: "1px solid rgba(15,23,42,0.08)",
                    "&:hover": { bgcolor: "rgba(59,130,246,0.08)" },
                  }}
                >
                  <Box sx={{ fontWeight: 900 }}>R{p.rallyIndex + 1}</Box>
                  <Box sx={{ fontSize: 12 }}>
                    <Box sx={{ fontWeight: 800 }}>
                      {riskRewardOutcomeLabel(mode, p)}
                      {p.lostOnShotA ? " · ended on shot" : ""}
                    </Box>
                    <Box sx={{ color: "rgba(15,23,42,0.68)" }}>
                      {speed == null ? "pace n/a" : `${Math.round(speed)} mph`} ·{" "}
                      {depth == null
                        ? "landing depth ignored"
                        : `${depth.toFixed(1)} ft from opponent baseline`}{" "}
                      ·{" "}
                      {angle == null ? "angle n/a" : `${Math.round(angle)} deg`}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    {typeof p.hitterPlayerId === "number"
                      ? renderPlayerIdentity({
                          playerId: p.hitterPlayerId,
                          avatarOnly: false,
                          size: 34,
                          borderRadius: 5,
                          fontSize: 11,
                        })
                      : null}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>

        <Box
          sx={{ minHeight: 0, display: "flex", flexDirection: "column", gap: 1 }}
        >
          <Box
            sx={{
              border: "1px solid rgba(15,23,42,0.14)",
              borderRadius: 1,
              bgcolor: "white",
              p: 1,
              minHeight: 86,
            }}
            data-demo="risk-reward-selected-summary"
          >
            <Box sx={{ fontWeight: 900 }}>
              {selectedPoint
                ? `Rally ${selectedPoint.rallyIndex + 1} · ${mode === "serve" ? "serve" : "return"}`
                : "No matching clip"}
            </Box>
            {selectedPoint ? (
              <Box
                sx={{ mt: 0.5, fontSize: 12, color: "rgba(15,23,42,0.70)" }}
              >
                {mode === "serve"
                  ? "Outcome is counted from the serving side: serving side won or serving side lost the rally."
                  : "Outcome is counted from the returning side: return side won the rally or serving side won the rally."}
              </Box>
            ) : null}
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              borderRadius: 1,
              overflow: "hidden",
              bgcolor: "black",
            }}
            data-demo="risk-reward-active-video"
          >
            {selectedRow && selectedPoint ? (
              <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
              <ActiveRallyVideo
                insightsToCvPlayerIndex={insightsToCvPlayerIndex}
                renderPlayerIdentity={renderPlayerIdentity}
                isInFullPopup={false}
                showPopoutButton={true}
                aiContextLabel="Serve/Return Outcome Review"
                focusedFilter={null}
                key={`risk-reward-${mode}-${
                  selectedPlayerId ?? "all"
                }-${riskRewardPointId(selectedPoint)}-${selectedRow.rallyIndex}`}
                controlsPlacement="bottom"
                row={selectedRow}
                packageId={packageId}
                rows={rows}
                activeShotNumber={mode === "serve" ? 1 : 2}
                beginningScore={(selectedRow as any).scoreBefore}
                endingScore={(selectedRow as any).scoreAfter}
                showCondensedTimeline={true}
                fontColor={"black"}
                firefightsClips={firefightsClips ?? ([] as any)}
                firefightRallySet={firefightRallySet ?? new Set<number>()}
                showRateControls={false}
                showScoreEtc={false}
                showTitle={false}
              />
              <Box
                sx={{
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  maxWidth: "calc(100% - 20px)",
                  px: 1,
                  py: 0.75,
                  borderRadius: 1.5,
                  bgcolor: "rgba(15,23,42,0.78)",
                  color: "white",
                  border: "1px solid rgba(125,211,252,0.38)",
                  pointerEvents: "none",
                }}
              >
                <Typography sx={{ fontSize: 11, fontWeight: 950, color: "#7dd3fc", letterSpacing: 0.4 }}>
                  {mode === "serve" ? "SERVE SETTINGS" : "RETURN SETTINGS"}
                </Typography>
                <Typography sx={{ fontSize: 12, fontWeight: 850 }}>
                  {selectedPointDetails}
                </Typography>
                <Typography sx={{ mt: 0.25, fontSize: 11, opacity: 0.78 }}>
                  Filters: {settingsSummary}
                </Typography>
              </Box>
              </Box>
            ) : (
              <Box sx={{ p: 2, color: "rgba(255,255,255,0.72)" }}>
                No matching video after the current filters.
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </FloatingPanel>
    {scanOpen && selectedPlayerId != null ? (
      <Box
        role="dialog"
        data-demo="risk-reward-scan-dialog"
        sx={{
          position: "fixed",
          inset: 24,
          zIndex: 2600,
          borderRadius: 2,
          bgcolor: "rgba(8,13,20,0.96)",
          color: "white",
          border: "1px solid rgba(125,211,252,0.35)",
          boxShadow: "0 22px 70px rgba(0,0,0,0.46)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 1.25,
            py: 0.9,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center", minWidth: 0 }}>
            <Typography sx={{ fontWeight: 950, fontSize: 18 }}>
              {mode === "serve" ? "Serve" : "Return"} outcome scan
            </Typography>
            {renderPlayerIdentity({
              playerId: selectedPlayerId,
              avatarOnly: false,
              size: 38,
              borderRadius: 6,
              fontSize: 12,
            })}
            <Typography sx={{ fontSize: 12, opacity: 0.78 }}>
              {filteredPoints.length} filtered clips
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 0.6, alignItems: "center" }}>
            {([1, 2, 4, 8] as const).map((value) => (
              <Button
                key={value}
                size="small"
                variant={scanPreviewScale === value ? "contained" : "outlined"}
                onClick={() => setScanPreviewScale(value)}
                sx={{ minWidth: 42, height: 26, textTransform: "none", fontWeight: 900 }}
              >
                {value === 1 ? "Full" : `1/${value}`}
              </Button>
            ))}
            <Button
              size="small"
              variant="outlined"
              onClick={() => setScanOpen(false)}
              sx={{ color: "white", borderColor: "rgba(255,255,255,0.35)", textTransform: "none", fontWeight: 900 }}
            >
              Close
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            px: 1.25,
            py: 0.8,
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(120px, 1fr))",
            gap: 0.8,
            borderBottom: "1px solid rgba(255,255,255,0.10)",
          }}
        >
          <Box sx={{ p: 0.8, borderRadius: 1, bgcolor: "rgba(34,197,94,0.16)" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 900 }}>{positiveOutcomeLabel}</Typography>
            <Typography sx={{ fontSize: 22, fontWeight: 950 }}>{rewardCount}</Typography>
          </Box>
          <Box sx={{ p: 0.8, borderRadius: 1, bgcolor: "rgba(248,113,113,0.16)" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 900 }}>{negativeOutcomeLabel}</Typography>
            <Typography sx={{ fontSize: 22, fontWeight: 950 }}>{riskCount}</Typography>
          </Box>
          <Box sx={{ p: 0.8, borderRadius: 1, bgcolor: "rgba(96,165,250,0.16)" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 900 }}>{rateLabel}</Typography>
            <Typography sx={{ fontSize: 22, fontWeight: 950 }}>{rewardPct}%</Typography>
          </Box>
          <Box sx={{ p: 0.8, borderRadius: 1, bgcolor: "rgba(255,255,255,0.08)" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 900 }}>Filters</Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 750 }}>{settingsSummary}</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            p: 1,
            display: "grid",
            gridTemplateColumns:
              scanPreviewScale === 1
                ? "repeat(2, minmax(420px, 1fr))"
                : scanPreviewScale === 2
                  ? "repeat(3, minmax(320px, 1fr))"
                  : scanPreviewScale === 4
                    ? "repeat(4, minmax(240px, 1fr))"
                    : "repeat(5, minmax(190px, 1fr))",
            alignContent: "start",
            gap: 1,
          }}
        >
          {filteredPoints.slice(0, 80).map((p) => {
            const row = rowByRallyIndex.get(p.rallyIndex) ?? null;
            const speed = pairPointSpeedMph(p);
            const depth = pairPointLandingDepthFromOpponentBaseline(p);
            const angle = pairPointAngleDeg(p);
            return (
              <Box
                key={riskRewardPointId(p)}
                sx={{
                  minHeight: scanPreviewScale === 1 ? 260 : scanPreviewScale === 2 ? 210 : 160,
                  border: "1px solid rgba(125,211,252,0.26)",
                  borderRadius: 1.25,
                  overflow: "hidden",
                  bgcolor: "rgba(0,0,0,0.50)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box sx={{ px: 0.7, py: 0.5, display: "flex", justifyContent: "space-between", gap: 1 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 950 }}>
                    R{p.rallyIndex + 1}
                  </Typography>
                  <Typography sx={{ fontSize: 11, fontWeight: 850, opacity: 0.82, textAlign: "right" }}>
                    {speed == null ? "pace n/a" : `${Math.round(speed)} mph`} ·{" "}
                    {depth == null ? "depth ignored" : `${depth.toFixed(1)} ft`} ·{" "}
                    {angle == null ? "angle n/a" : `${Math.round(angle)} deg`}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, minHeight: 0 }}>
                  {row ? (
                    <ActiveRallyVideo
                      insightsToCvPlayerIndex={insightsToCvPlayerIndex}
                      renderPlayerIdentity={renderPlayerIdentity}
                      isInFullPopup={false}
                      showPopoutButton={true}
                      aiContextLabel="Serve/Return Outcome Review"
                      focusedFilter={null}
                      controlsPlacement="bottom"
                      row={row}
                      packageId={packageId}
                      rows={rows}
                      activeShotNumber={mode === "serve" ? 1 : 2}
                      beginningScore={(row as any).scoreBefore}
                      endingScore={(row as any).scoreAfter}
                      showCondensedTimeline={false}
                      fontColor={"white"}
                      firefightsClips={firefightsClips ?? ([] as any)}
                      firefightRallySet={firefightRallySet ?? new Set<number>()}
                      showRateControls={false}
                      showScoreEtc={false}
                      showTitle={false}
                      showShotLabels={false}
                      previewMode
                      forceMuted
                    />
                  ) : null}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    ) : null}
    </>
  );
}

type HoverState = {
  id: string | null;
  p: PairPoint | null;
  client: { x: number; y: number } | null;
};

function ServeReturnBase(props: {
  insightsToCvPlayerIndex: PlayerIndexMap;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;

  packageId: string;
  rows: KitchenArrivalRow[];
  playerIdToTeam: (playerId: number | null) => 0 | 1 | null;
  teamColor: (team: 0 | 1, alpha?: number) => string;
  renderPlayerIdentity: RenderPlayerIdentity;

  popupW_VideoPart: string | number;
  popupH_VideoPart: string | number;

  firefightsClips?: FirefightClip[];
  firefightRallySet?: Set<number>;

  title: string;
  // fromShotNumber: number;
  // shotB: number;
  activeShotNumberForVideo: number;
  aLabel: string;
  bLabel: string;
  mode: ServeReturnPopupMode;
}) {
  const {
    open,
    onClose,
    packageId,
    rows,
    playerIdToTeam,
    teamColor,
    firefightsClips,
    firefightRallySet,
    title,
    // fromShotNumber,
    // shotB,
    activeShotNumberForVideo,
    aLabel,
    bLabel,
    mode,
    insightsToCvPlayerIndex,
    renderPlayerIdentity,
  } = props;

  const [mainRect, setMainRect] = React.useState<FloatingRect>(() => ({
    x: 24,
    y: 24,
    w: 1560,
    h: 900,
  }));

  const didCenterMainRef = React.useRef(false);

  const [pinnedRect, setPinnedRect] = React.useState<FloatingRect>(() => ({
    x: 24,
    y: 24,
    w: 720,
    h: 450,
  }));

  const [pinnedRallyIndex, setPinnedRallyIndex] = React.useState<number | null>(
    null,
  );

  const [hoverPoint, setHoverPoint] = React.useState<PairPoint | null>(null);

  const handleHover = React.useCallback(
    (_id: string | null, p: PairPoint | null, _e?: React.MouseEvent<any>) => {
      // optional stability: only update when the *point* changes
      setHoverPoint((prev) => {
        if (!prev || !p) return p;
        if (prev.rallyIndex === p.rallyIndex && prev.pointKey === p.pointKey)
          return prev;
        return p;
      });
    },
    [],
  );

  //   const [hover, setHover] = React.useState<PairPoint | null>(null);

  //   const courtsWrapRef = React.useRef<HTMLDivElement | null>(null);

  //   const [hoveredPoint, setHoveredPoint] = React.useState<PairPoint | null>(
  //     null,
  //   );

  //   const [hoverUi, setHoverUi] = React.useState<{
  //     p: PairPoint;
  //     x: number;
  //     y: number;
  //   } | null>(null);
  //   const hover: PairPoint | null = hoverUi?.p ?? null;

  //   const [hoverA, setHoverA] = React.useState<HoverState>({
  //     id: null,
  //     p: null,
  //     client: null,
  //   });
  //   const [hoverB, setHoverB] = React.useState<HoverState>({
  //     id: null,
  //     p: null,
  //     client: null,
  //   });

  //   function mkHoverSetter(setter: React.Dispatch<React.SetStateAction<HoverState>>) {
  //   return (id: string | null, p: PairPoint | null, e?: React.MouseEvent<any>) => {
  //     const client = e ? { x: e.clientX, y: e.clientY } : null;

  //     setter((prev) => {

  //       return prev;
  //       // // If we're still on the same point, don't touch id/p (prevents flashing).
  //       // if (prev.id === id) {
  //       //   // only update mouse position for tooltip
  //       //   if (client && (!prev.client || prev.client.x !== client.x || prev.client.y !== client.y)) {
  //       //     return { ...prev, client };
  //       //   }
  //       //   return prev;
  //       // }

  //       // // Point changed (or cleared)
  //       // return { id, p, client };
  //     });
  //   };
  // }

  // const handleHoverA = React.useMemo(() => mkHoverSetter(setHoverA), []);
  // const handleHoverB = React.useMemo(() => mkHoverSetter(setHoverB), []);

  // const handleHoverA = React.useCallback(
  //   (id: string | null, p: PairPoint | null, e?: React.MouseEvent<any>) => {
  //     setHoverA({
  //       id,
  //       p,
  //       client: e ? { x: e.clientX, y: e.clientY } : null,
  //     });
  //   },
  //   [],
  // );

  // const handleHoverB = React.useCallback(
  //   (id: string | null, p: PairPoint | null, e?: React.MouseEvent<any>) => {
  //     setHoverB({
  //       id,
  //       p,
  //       client: e ? { x: e.clientX, y: e.clientY } : null,
  //     });
  //   },
  //   [],
  // );

  // const handleHover = React.useCallback(
  //   (
  //     hoverId: string | null,
  //     p: PairPoint | null,
  //     e?: React.MouseEvent<any>,
  //   ) => {
  //     console.error("hoverId", hoverId);
  //     setHoverId(hoverId);
  //     if (!p) {
  //       setHoverUi(null);
  //       return;
  //     }
  //     const rect = courtsWrapRef.current?.getBoundingClientRect();
  //     if (!rect || !e) {
  //       setHoverUi({ p, x: 0, y: 0 });
  //       return;
  //     }
  //     setHoveredPoint(p);

  //     //setHoverId(`${p.rallyIndex}-${p.pointKey ?? "null"}`);
  //     setHoverId(hoverId);
  //     setHoverUi({ p, x: e.clientX - rect.left, y: e.clientY - rect.top });
  //   },
  //   [],
  // );

  const rowByRallyIndex = React.useMemo(() => {
    const m = new Map<number, KitchenArrivalRow>();
    for (const r of rows) m.set(r.rallyIndex, r);
    return m;
  }, [rows]);

  const pinnedRow = React.useMemo(() => {
    if (pinnedRallyIndex == null) return null;
    return rowByRallyIndex.get(pinnedRallyIndex) ?? null;
  }, [rowByRallyIndex, pinnedRallyIndex]);

  // const hoverRow = React.useMemo(() => {
  //   if (!hover) return null;
  //   return rowByRallyIndex.get(hover.rallyIndex) ?? null;
  // }, [rowByRallyIndex, hover]);

  const hoverRow = React.useMemo(() => {
    if (!hoverPoint) return null;
    return rowByRallyIndex.get(hoverPoint.rallyIndex) ?? null;
  }, [hoverPoint, rowByRallyIndex]);

  React.useEffect(() => {
    if (!open) {
      didCenterMainRef.current = false;
      return;
    }
    if (didCenterMainRef.current) return;

    const w = mainRect.w;
    const h = mainRect.h;

    const x = Math.max(8, Math.floor((window.innerWidth - w) / 2));
    const y = Math.max(8, Math.floor((window.innerHeight - h) / 2));

    setMainRect({ x, y, w, h });
    didCenterMainRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const points = React.useMemo(() => {
    return extractPairPoints({ mode, rows, playerIdToTeam });
  }, [rows, playerIdToTeam]);

  // const playerIdsByTeam = React.useMemo(() => {
  //   const by: Record<Team01, number[]> = { 0: [], 1: [] };
  //   const seen0 = new Set<number>();
  //   const seen1 = new Set<number>();
  //   for (const p of points) {
  //     const pid = p.hitterPlayerId;
  //     if (typeof pid !== "number") continue;
  //     if (p.hitterTeam === 0) { if (!seen0.has(pid)) { seen0.add(pid); by[0].push(pid); } }
  //     else { if (!seen1.has(pid)) { seen1.add(pid); by[1].push(pid); } }
  //   }
  //   by[0].sort((a, b) => a - b);
  //   by[1].sort((a, b) => a - b);
  //   return by;
  // }, [points]);

  const [playerFilterT0, setPlayerFilterT0] = React.useState<number | null>(
    null,
  );
  const [playerFilterT1, setPlayerFilterT1] = React.useState<number | null>(
    null,
  );

  // React.useEffect(() => {
  //   if (playerFilterT0 != null && !playerIdsByTeam[0].includes(playerFilterT0)) setPlayerFilterT0(null);
  //   if (playerFilterT1 != null && !playerIdsByTeam[1].includes(playerFilterT1)) setPlayerFilterT1(null);
  // }, [playerFilterT0, playerFilterT1, playerIdsByTeam]);

  // const filteredPoints = React.useMemo(() => points.filter((p) => {
  //   if (p.hitterTeam === 0 && playerFilterT0 != null && p.hitterPlayerId !== playerFilterT0) return false;
  //   if (p.hitterTeam === 1 && playerFilterT1 != null && p.hitterPlayerId !== playerFilterT1) return false;
  //   return true;
  // }), [points, playerFilterT0, playerFilterT1]);

  //
  const playerIdsByTeam = React.useMemo(() => {
    const by: Record<Team01, number[]> = { 0: [], 1: [] };
    const seen0 = new Set<number>();
    const seen1 = new Set<number>();

    for (const p of points) {
      for (const pid of [p.hitterPlayerId, p.receiverPlayerId]) {
        if (typeof pid !== "number") continue;
        const team = playerIdToTeam(pid);
        if (team === 0) {
          if (!seen0.has(pid)) {
            seen0.add(pid);
            by[0].push(pid);
          }
        } else if (team === 1) {
          if (!seen1.has(pid)) {
            seen1.add(pid);
            by[1].push(pid);
          }
        }
      }
    }

    by[0].sort((a, b) => a - b);
    by[1].sort((a, b) => a - b);
    return by;
  }, [points, playerIdToTeam]);

  const [selectedPlayerId, setSelectedPlayerId] = React.useState<number | null>(
    null,
  );

  React.useEffect(() => {
    if (selectedPlayerId == null) return;
    const stillExists =
      playerIdsByTeam[0].includes(selectedPlayerId) ||
      playerIdsByTeam[1].includes(selectedPlayerId);
    if (!stillExists) setSelectedPlayerId(null);
  }, [selectedPlayerId, playerIdsByTeam]);

  const filteredPoints = React.useMemo(
    () =>
      points.filter((p) => {
        if (selectedPlayerId == null) return true;
        return (
          p.hitterPlayerId === selectedPlayerId ||
          p.receiverPlayerId === selectedPlayerId
        );
      }),
    [points, selectedPlayerId],
  );

  const selectedPlayerTeam = React.useMemo(
    () => (selectedPlayerId == null ? null : playerIdToTeam(selectedPlayerId)),
    [selectedPlayerId, playerIdToTeam],
  );

  // X-axis mirroring. If it feels backwards on your camera angle, flip this.
  const flipX = false; //true;

  //   const W = 200;
  // const H = 320; //440;

  const W = COURT_SVG_W;
  const H = COURT_SVG_H;

  const xPad = 8;
  const yPad = 4;

  const sxAbsToSvg = (xFeet: number) =>
    flipX ? (1 - xFeet / 20) * W : (xFeet / 20) * W;

  const syAbsToSvg = (team: Team01, yAbsFeet: number) => {
    const yRel = team === 1 ? 44 - yAbsFeet : yAbsFeet;

    return team === 0 ? (yRel / 44) * H : (1 - yRel / 44) * H;
  };

  const vb0 = computeViewBoxForTeam({
    team: 0,
    points: filteredPoints,
    sxAbsToSvg,
    syAbsToSvg,
    xPad,
    yPad,
  });

  const vb1 = computeViewBoxForTeam({
    team: 1,
    points: filteredPoints,
    sxAbsToSvg,
    syAbsToSvg,
    xPad,
    yPad,
  });

  const sharedViewBox = unionViewBox(vb0, vb1);

  const minViewHeight = 0; //180;
  const minViewWidth = 120;

  const sharedViewBoxTight = React.useMemo(() => {
    let { minX, minY, w, h } = sharedViewBox;

    const actualMaxY = minY + h;

    // Always include the full court vertically, plus any out-of-bounds dots
    const paddedMinY = Math.min(0, minY);
    const paddedMaxY = Math.max(H, actualMaxY);

    minY = paddedMinY;
    h = paddedMaxY - paddedMinY;

    // Force the viewBox to match the court aspect ratio so SVG "meet"
    // doesn't introduce top/bottom blank space.
    const targetW = h * COURT_ASPECT_RATIO;
    const currentCenterX = minX + w / 2;

    if (w < targetW) {
      w = targetW;
      minX = currentCenterX - w / 2;
    }

    return { minX, minY, w, h };
  }, [sharedViewBox, H]);

  const openPinned = React.useCallback((p: PairPoint) => {
    setPinnedRallyIndex(p.rallyIndex);

    const w = 720;
    const h = 450;

    const x = Math.max(8, Math.floor((window.innerWidth - w) / 2));
    const y = Math.max(8, Math.floor((window.innerHeight - h) / 2));

    const x2 = Math.min(window.innerWidth - w - 8, x);
    const y2 = Math.min(window.innerHeight - h - 8, y);

    setPinnedRect({ x: x2, y: y2, w, h });
  }, []);

  const closePinned = React.useCallback(() => setPinnedRallyIndex(null), []);

  const pinnedPoint = React.useMemo(() => {
    if (pinnedRallyIndex == null) return null;
    return (
      filteredPoints.find((pp) => pp.rallyIndex === pinnedRallyIndex) ??
      points.find((pp) => pp.rallyIndex === pinnedRallyIndex) ??
      null
    );
  }, [filteredPoints, points, pinnedRallyIndex]);

  const t0 = filteredPoints.filter((p) => p.hitterTeam === 0);
  const t1 = filteredPoints.filter((p) => p.hitterTeam === 1);

  const t0PlayerStats = React.useMemo(
    () => statsByPlayer(filteredPoints, 0),
    [filteredPoints],
  );
  const t1PlayerStats = React.useMemo(
    () => statsByPlayer(filteredPoints, 1),
    [filteredPoints],
  );

  if (!open) return null;

  // mph cutoff: serve tends higher than return; keep these easy to tweak
  const mphCutoff = aLabel === "Serve" ? 35 : 28;

  return (
    <>
      <FloatingPanel
        open={open}
        rect={mainRect}
        onChangeRect={setMainRect}
        onClose={onClose}
        title={title}
        minW={1200}
        minH={720}
        color="black"
      >
        {/* <Box sx={{ display: "flex", gap: 1, height: "100%", p: 1 }}> */}
        <Box sx={{ display: "flex", gap: 0.75, height: "100%", p: 0.75 }}>
          {/* <Box sx={{ width: 260, minWidth: 260, display: "flex", flexDirection: "column", gap: 1 }}> */}
          <Box
            sx={{
              width: 270,
              minWidth: 270,
              display: "flex",
              flexDirection: "column",
              gap: 0.75,
            }}
          >
            <Box sx={{border:"4px solid " + teamColor(0, 0.5), borderRadius:2, paddingLeft: "4px",}}>

              <PlayerFilter
              team={0}
              teamColor={teamColor}
              availablePlayerIds={playerIdsByTeam[0]}
              selectedPlayerId={selectedPlayerId} // playerFilterT0}
              onSelect={setSelectedPlayerId} //setPlayerFilterT0}
              renderPlayerIdentity={renderPlayerIdentity}
            />
            <TeamSummary
              team={0}
              title=""
              points={t0}
              allPoints={filteredPoints}
              playerStats={t0PlayerStats}
              selectedPlayerId={selectedPlayerId} //playerFilterT0}
              teamColor={teamColor}
              renderPlayerIdentity={renderPlayerIdentity}
              aLabel={aLabel}
              bLabel={bLabel}
            />

            </Box>

            <Box sx={{border:"4px solid " + teamColor(1, 0.5), borderRadius:2, paddingLeft: "4px",}}>

            <PlayerFilter
              team={1}
              teamColor={teamColor}
              availablePlayerIds={playerIdsByTeam[1]}
              selectedPlayerId={selectedPlayerId} //playerFilterT1}
              onSelect={setSelectedPlayerId} //setPlayerFilterT1}
              renderPlayerIdentity={renderPlayerIdentity}
            />

            <TeamSummary
              team={1}
              title={""} //"Team 1"
              points={t1}
              allPoints={filteredPoints}
              playerStats={t1PlayerStats}
              selectedPlayerId={selectedPlayerId} //playerFilterT1}
              teamColor={teamColor}
              renderPlayerIdentity={renderPlayerIdentity}
              aLabel={aLabel}
              bLabel={bLabel}
            />
            </Box>
          </Box>

          {/* two courts */}
          {/* <Box
            sx={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", gap: 1 }}
          > */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              display: "flex",
              gap: 0.75,
            }}
          >
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  px: 0.25,
                }}
              >
                <Box sx={{ fontWeight: 700, fontSize: 13 }}>
                  Team 0 • {t0.length}{" "}
                  {mode === "serve_return" ? "serves" : "returns"}
                </Box>
              </Box> */}
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  display: "flex",
                  // alignItems: "center",
                  // justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    minHeight: 0,
                  }}
                >
                  <CourtSvg
                    team={0}
                    topLabel={`${aLabel} Contact`}
                    bottomLabel={`${bLabel} Contact`}
                    aLabelText={`${aLabel} Contact`}
                    bLabelText={`${bLabel} Contact`}
                    aIsTop={true}
                    points={t0}
                    teamColor={teamColor}
                    mphCutoff={mphCutoff}
                    onHoverRally={handleHover}
                    // hoveredId={hoverA?.id ?? null}
                    onClickRally={openPinned}
                    flipX={flipX}
                    viewBox={sharedViewBoxTight}
                    selectedPlayerId={selectedPlayerId}
                    selectedPlayerTeam={selectedPlayerTeam}
                    renderPlayerIdentity={renderPlayerIdentity}
                    //autoFlipY={true}
                  />
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  px: 0.25,
                }}
              >
                <Box sx={{ fontWeight: 700, fontSize: 13 }}>
                  Team 1 • {t1.length}{" "}
                  {mode === "serve_return" ? "serves" : "returns"}
                </Box>
              </Box> */}
              <Box
                sx={{
                  flex: 1,
                  minWidth: 0,
                  minHeight: 0,
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    minHeight: 0,
                  }}
                >
                  <CourtSvg
                    team={1}
                    topLabel={`${bLabel} Contact`}
                    bottomLabel={`${aLabel} Contact`}
                    aLabelText={`${aLabel} Contact`}
                    bLabelText={`${bLabel} Contact`}
                    aIsTop={false}
                    points={t1}
                    teamColor={teamColor}
                    mphCutoff={mphCutoff}
                    onHoverRally={handleHover}
                    // onHoverRally={handleHoverB}
                    // hoveredId={hoverB?.id ?? null}
                    onClickRally={openPinned}
                    flipX={flipX}
                    viewBox={sharedViewBoxTight}
                    selectedPlayerId={selectedPlayerId}
                    selectedPlayerTeam={selectedPlayerTeam}
                    renderPlayerIdentity={renderPlayerIdentity}
                    //autoFlipY={true}
                  />
                </Box>
              </Box>
            </Box>
          </Box>

          {/* right hover panel */}
          {/* <Box
            sx={{
              width: 420,
              minWidth: 420,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          > */}
          <Box
            sx={{
              width: 430,
              minWidth: 430,
              display: "flex",
              flexDirection: "column",
              gap: 0.75,
            }}
          >
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,0.12)",
                borderRadius: 1,
                p: 1,
                bgcolor: "rgba(255,255,255,0.92)",
              }}
            >
              <Box sx={{ fontWeight: 800, fontSize: 14, mb: 0.5 }}>Legend</Box>
              <Box sx={{ fontSize: 12, opacity: 0.85 }}>
                <Box>
                  Dots: {aLabel} or {bLabel} contact location
                </Box>
                <Box>Dashed lines: trajectories</Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 0.45,
                  }}
                >
                  <Box sx={{ width: 14, height: 14, position: "relative" }}>
                    <svg
                      viewBox="0 0 14 14"
                      style={{ width: 14, height: 14, display: "block" }}
                    >
                      <circle
                        cx="7"
                        cy="7"
                        r="5.2"
                        fill="none"
                        stroke="rgba(220, 38, 38, 0.95)"
                        strokeWidth="2"
                      />
                    </svg>
                  </Box>
                  <Box>Red circle: point ended on that shot</Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 0.6,
                  }}
                >
                  <Box sx={{ width: 14, height: 14, position: "relative" }}>
                    <svg
                      //component="svg"
                      viewBox="0 0 14 14"
                      style={{ width: 14, height: 14, display: "block" }}
                    >
                      <line
                        x1="3"
                        y1="3"
                        x2="11"
                        y2="11"
                        stroke="rgba(0,0,0,0.85)"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <line
                        x1="3"
                        y1="11"
                        x2="11"
                        y2="3"
                        stroke="rgba(0,0,0,0.85)"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Box>
                  <Box>Black X: lost rally on shot</Box>
                </Box>
              </Box>
              <Box
                sx={{
                  fontSize: 12,
                  opacity: 0.75,
                  marginTop: "4px",
                  fontStyle: "italic",
                  marginBottom: "4px",
                }}
              >
                Hover a line/dot to preview. Click to open pinned video.
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                border: "1px dashed rgba(0,0,0,0.25)",
                borderRadius: 1,
                bgcolor: "rgba(255,255,255,0.92)",
                overflow: "hidden",
                p: hoverRow ? 0 : 1,
              }}
            >
              {!hoverRow ? (
                <Box sx={{ fontSize: 13, opacity: 0.75 }}>
                  Hover a line/dot to preview here.
                </Box>
              ) : (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                  }}
                >
                  {/* context + mini court */}
                  {hoverPoint && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "stretch",
                        gap: 1,
                        p: 0.8,
                        borderBottom: "1px solid rgba(0,0,0,0.10)",
                        bgcolor: "rgba(0,0,0,0.02)",
                      }}
                    >
                      <CourtMiniPair
                        p={hoverPoint}
                        teamColor={teamColor}
                        flipX={flipX}
                        aLabel={aLabel}
                        bLabel={bLabel}
                      />

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box sx={{ fontSize: 12, fontWeight: 900 }}>
                          Rally {hoverRow.rallyIndex + 1} · Team{" "}
                          {hoverPoint.hitterTeam}{" "}
                          {hoverPoint.hitterPlayerId != null
                            ? renderPlayerIdentity
                              ? renderPlayerIdentity({
                                  playerId: hoverPoint.hitterPlayerId,
                                  labelOnly: false,
                                  size: 40,
                                  borderRadius: 5,
                                  fontSize: 12,
                                })
                              : `· p${hoverPoint.hitterPlayerId}`
                            : ""}
                        </Box>
                        <Box sx={{ fontSize: 12, mt: 0.25 }}>
                          {aLabel} → {bLabel}
                          {hoverPoint.mph != null &&
                          Number.isFinite(hoverPoint.mph)
                            ? ` · ${Math.round(hoverPoint.mph)}mph`
                            : ""}
                        </Box>
                        <Box sx={{ fontSize: 12, mt: 0.25 }}>
                          {hoverPoint.wonRally == null
                            ? ""
                            : hoverPoint.wonRally
                              ? "Won rally"
                              : "Lost rally"}
                        </Box>
                      </Box>
                    </Box>
                  )}

                  <Box
                    data-demo="shot-location-hover-preview"
                    sx={{ flex: "1 1 auto", minHeight: 0 }}
                  >
                    <ActiveRallyVideo
                      insightsToCvPlayerIndex={insightsToCvPlayerIndex}
                      renderPlayerIdentity={renderPlayerIdentity}
                      isInFullPopup={false}
                      showPopoutButton={true}
                      aiContextLabel="Serves/Returns"
                      focusedFilter={null}
                      key={`hover-${title}-${hoverRow.rallyIndex}`}
                      controlsPlacement="left"
                      row={hoverRow}
                      packageId={packageId}
                      rows={rows}
                      activeShotNumber={activeShotNumberForVideo}
                      beginningScore={(hoverRow as any).scoreBefore}
                      endingScore={(hoverRow as any).scoreAfter}
                      showCondensedTimeline={false}
                      fontColor={"black"}
                      firefightsClips={firefightsClips ?? ([] as any)}
                      firefightRallySet={firefightRallySet ?? new Set<number>()}
                      showRateControls={false}
                      showScoreEtc={false}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </FloatingPanel>

      {/* pinned video */}
      {pinnedRow && (
        <FloatingPanel
          open={true}
          rect={pinnedRect}
          onChangeRect={setPinnedRect}
          onClose={closePinned}
          title={`Rally ${pinnedRow.rallyIndex + 1} ${aLabel} → ${bLabel}`}
          minW={1320}
          minH={620}
          color="black"
          dataDemo="shot-location-pinned-video"
        >
          <Box sx={{ p: 0.75, height: "100%" }}>
            <ActiveRallyVideo
              insightsToCvPlayerIndex={insightsToCvPlayerIndex}
              renderPlayerIdentity={renderPlayerIdentity}
              isInFullPopup={false}
              showPopoutButton={true}
              aiContextLabel="Serves/Returns"
              condensedTimelineLeftEl={
                pinnedPoint ? (
                  <Box
                    sx={{
                      marginRight: "6px",
                      width: MINI_COURT_WIDTH,
                      height: MINI_COURT_HEIGHT,
                    }}
                  >
                    <CourtMiniPair
                      p={pinnedPoint}
                      teamColor={teamColor}
                      flipX={flipX}
                      aLabel={aLabel}
                      bLabel={bLabel}
                    />
                  </Box>
                ) : null
              }
              showAi={true}
              aiDrawerMode="split"
              focusedFilter={null}
              key={`pinned-${title}-${pinnedRow.rallyIndex}`}
              controlsPlacement="left"
              row={pinnedRow}
              packageId={packageId}
              rows={rows}
              activeShotNumber={activeShotNumberForVideo}
              beginningScore={(pinnedRow as any).scoreBefore}
              endingScore={(pinnedRow as any).scoreAfter}
              showCondensedTimeline={true}
              fontColor={"black"}
              firefightsClips={firefightsClips ?? ([] as any)}
              firefightRallySet={firefightRallySet ?? new Set<number>()}
              showRateControls={false}
              showScoreEtc={false}
              showTitle={false}
            />
          </Box>
        </FloatingPanel>
      )}
    </>
  );
}
